/* eslint-disable max-lines */
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5de
import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import {
  isClient,
  getIcidValue,
  createBVUrl,
  isUsOnly,
  getBrand,
  fireEnhancedEcomm,
  getViewportInfo,
  formatPromotionMessage,
  markRUMTimings,
  getAssetHostURL,
  getHost,
  isCanada,
  getPromotionalMessage,
  isServer,
  isGymboree,
} from '@tcp/core/src/utils';
import { getMonetateEnabledFlag } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';
import {
  getSessionStorage,
  setSessionStorage,
  getDimension2Value,
  getGAPageName,
  getCategoryIdAndName,
  getBrandName,
  createPromoArray,
} from '@tcp/core/src/utils/utils.web';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getParam } from '@tcp/core/src/analytics/utils';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import DynamicModule from '@tcp/core/src/components/common/atoms/DynamicModule';
import smoothscroll from 'smoothscroll-polyfill';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import { isTier1Device, isTier3Device } from '@tcp/web/src/utils/device-tiering';
import { PRODUCT_ADD_TO_BAG } from '@tcp/core/src/constants/reducer.constants';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import CustomBadge from '@tcp/core/src/components/features/browse/ProductDetail/molecules/CustomBadge';
import {
  getTopRatedBadge,
  getBestSellerBadge,
  getMostFavoriteBadge,
  hideProductOriginalPrice,
  getOriginalPrice,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import SyteRecommendations from '@tcp/web/src/components/common/vendors/Syte/Recommendations';
import BadgesProvider from '@tcp/core/src/components/features/browse/Badges/provider/Badges.provider.jsx';
import {
  TOP_RATED,
  BEST_SELLER,
  MOST_FAVORITED,
  TOP_RATED_ANALYTICS_STRING,
  BEST_SELLER_ANALYTICS_STRING,
  MOST_FAVORITED_ANALYTICS_STRING,
} from '@tcp/core/src/constants/badge.constants';
import ANALYTICS_CONSTANTS from '@tcp/web/src/constants/AnalyticsConstants';
import { TIER1 } from '@tcp/core/src/constants/tiering.constants';
import ModuleX from '@tcp/core/src/components/common/molecules/ModuleX/ModuleX.jsx';
import PointsAndRewards from '@tcp/core/src/components/features/browse/ProductDetail/molecules/PointsAndRewards';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import PDPNewTabs from '@tcp/core/src/components/features/browse/ProductDetail/views/PDPTabs.view.jsx';
import getPdpBrandLabel from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductBasicInfo/helpers/ProductBasicInfoHelper';
import withStyles from '../../../../common/hoc/withStyles';
import ProductDetailStyle, {
  customSubmitButtonStyle,
  recommendationStylesPdp,
  recommendationStylesPdp1AndPdp2,
  StyledModuleLoader,
} from '../ProductDetail.style';
import {
  checkInWishlistUtil,
  getImagesToDisplay,
  getPrimaryImages,
  getMapSliceForColorProductId,
  getMapSliceForColor,
  getFeatures,
  getMapColorList,
  getMapSliceForSizeSkuID,
  setMinMaxPrice,
  getIsAccessoryPresentMandatory,
  getIsESGBadgeAnalyticsString,
  getCurrentProductBadges,
  loadOutfitV3,
  calculateFinalPrice,
} from '../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import { PRODUCT_INFO_PROP_TYPE_SHAPE } from '../../ProductListing/molecules/ProductList/propTypes/productsAndItemsPropTypes';
import Product from '../molecules/Product/views/Product.view';
import FixedBreadCrumbs from '../../ProductListing/molecules/FixedBreadCrumbs/views';
import ProductAddToBagContainer from '../../../../common/molecules/ProductAddToBag';
import SIZE_CHART_LINK_POSITIONS from '../../../../common/molecules/ProductAddToBag/container/ProductAddToBag.config';
import names from '../../../../../constants/eventsName.constants';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import {
  routerPush,
  getIconPath,
  isValidObj,
  parseBoolean,
  getAPIConfig,
} from '../../../../../utils';
import ProductDescription from '../molecules/ProductDescription/views';
import LoyaltyBanner from '../../../CnC/LoyaltyBanner';
import ProductPrice from '../molecules/ProductPrice/ProductPrice';
import ProductImagesWrapper from '../molecules/ProductImagesWrapper/views/ProductImagesWrapper.view';
import ProductReviewsContainer from '../../ProductListing/molecules/ProductReviews/container/index.async';
import ProductDetailsUtils, { getVariantsForSeo } from './ProductDetail.utils';
import PdpVmpDataLogger from './PdpVmpDataLogger.view';
import ToastModal from '../../../account/common/molecule/ToastModal/views/ToastModal';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import { CmnBrowse, PdpSub, pdpLabels } from './ProductDetail.labels';
import PlccWrapperStatic from '../molecules/PlccWrapperStatic/views/PlccWrapperStatic.view';
import { getZoneOneBadgesArray } from '../../../../../utils/badge.util';
import { RedesignPDPPromotionalMessage } from '../../ProductListing/molecules/ProductList/views/ProductItemComponents';
import {
  DIMENSION92_TEXT,
  changeOnlyFirstLetterToCapital,
  formatDateFromDay,
} from '../../../../../utils/utils';
import {
  PRODUCT_PICKUP_LABELS,
  labelsObject,
  shippingLabelFromGenericLabels,
} from '../../../../common/organisms/PickupStoreModal/molecules/PickupStoreSelectionForm/views/PickupStoreSelectionForm.labels';
import { getQuickViewLabelsCopy } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import {
  QUICK_VIEW_LABELS,
  quickViewLabels,
} from '../../../../common/organisms/QuickViewModal/Labels/QuickView.labels';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '../../../../../utils/labels/globalCommonBrowseLabels.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
} from '../../../../../utils/labels/globalAccessibility.labels';
import { GlobalGenericLabels } from '../../../../../utils/labels/globalGeneric.labels';
import { GlobalAddToBagLabels } from '../../../../../utils/labels/globalAddedToBag.labels';
import globalCartItemTileLabels from '../../../../../utils/labels/globalCartItemTile.labels';
import StoreSpecialPromotion from '../molecules/StoreSpecialPromotion/StoreSpecialPromotion';
import PromoPDPBanners from '../../../../common/organisms/PromoPDPBanners';
import {
  ARROW_VISIBLE_SIMILAR_PRODUCTS,
  calculateBreakPointByWidth,
  SLIDES_TO_SCROLL_SIMILAR_PRODUCTS,
} from '../container/ProductDetail.config';
import AccountCommonLabels, {
  GLOBAL_LABELS,
} from '../../../account/common/labels/AccountCommon.labels';
import Carousel from '../../../../common/molecules/ModuleTabbedCarousel/molecules/Carousel';
import SimilarProductsModal from '../../../../common/organisms/SimilarProductModal/views/SimilarProductsModal.view';

const FamilyOutfit = dynamic(
  () => import(/* webpackChunkName: "familyoutfit" */ '../molecules/FamilyOutfit/FamilyOutfit'),
  { ssr: false }
);
const RelatedOutfits = dynamic(
  () => import(/* webpackChunkName: "relatedOutfits" */ '../molecules/RelatedOutfits/views'),
  { ssr: true }
);

const SendAnEmailGiftCard = dynamic(() =>
  import(/* webpackChunkName: "send-email-gift-card" */ '../molecules/SendAnEmailGiftCard')
);

const SimilarItemToConsider = dynamic(() =>
  import(/* webpackChunkName: "similar-items-to-consider" */ '../molecules/SimilarItemToConsider')
);

const Script = dynamic(() => import('@tcp/web/src/components/common/atoms/Script'), { ssr: false });

const KeyFeatures = dynamic(
  () =>
    import(
      /* webpackChunkName: "key-features" */ '@tcp/core/src/components/features/browse/ProductDetail/molecules/KeyFeatures'
    ),
  { ssr: false }
);
const Recommendations = dynamic(
  () =>
    import(
      /* webpackChunkName: "recommendations" */ '@tcp/core/src/components/common/molecules/Recommendations'
    ),
  {
    ssr: true,
  }
);

const { RECOMMENDATION } = Constants;

const sendMonetateEvents = (recToken, sendEventsToMonetateActn) => {
  if (recToken && sendEventsToMonetateActn) {
    sendEventsToMonetateActn({ recToken: [recToken], isRecsClick: true });
  }
};
class ProductDetailView extends React.PureComponent {
  pdpSubLabelsObj = getLabelFromCopyOrFromTranslation(PDP_SUB_LABELS, pdpSubLabels);

  constructor(props) {
    super(props);
    this.productTileRef = React.createRef();
    const {
      productInfo: { colorFitsSizesMap, generalProductId, offerPrice },
      alternateBrand,
      isBMModalOpen,
      dynamicContentPromo,
    } = this.props;
    this.state = {
      currentColorEntry:
        getMapSliceForColorProductId(
          colorFitsSizesMap,
          generalProductId?.replace(`$brand=${alternateBrand}`, '')
        ) || {},
      currentGiftCardValue: offerPrice,
      renderReceiveProps: false,
      showBazaarVoice: false,
      starRatingClicked: false,
      minOfferPrice: null,
      maxOfferPrice: null,
      minListPrice: null,
      maxListPrice: null,
      syteRecos: null,
      isBMModalOpen,
      isAnalyticsTriggered: false,
      promotionPrice: null,
      isDynamicComponentReady: dynamicContentPromo && dynamicContentPromo.length,
      isPickupSelectedAtProductDetail: false,
      hasMounted: false,
    };
    this.updateDeliveryMethodSelection = null;

    this.pdpLabel = this.getPdpLabels();
    this.globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
    const qvLabelsObj = {
      ...getLabelFromCopyOrFromTranslation(QUICK_VIEW_LABELS, quickViewLabels),
      ...getLabelFromCopyOrFromTranslation(GLOBAL_COMMON_BROWSE_LABELS, globalCommonBrowseLabels),
      ...getLabelFromCopyOrFromTranslation(GLOBAL_ACCESSIBILITY_LABELS, GlobalAccessibilityLabels),
      lbl_shipping: getLabelFromCopyOrFromTranslation(
        shippingLabelFromGenericLabels,
        GlobalGenericLabels
      ),
      lbl_Product_pickup_SELECTED_STORE: getLabelFromCopyOrFromTranslation(
        `${PRODUCT_PICKUP_LABELS}.lbl_Product_pickup_SELECTED_STORE`,
        labelsObject
      ),
      lbl_pickup_instead_free_order: getLabelFromCopyOrFromTranslation(
        `global.addedToBagModal.lbl_pickup_instead_free_order`,
        GlobalAddToBagLabels
      ),
      lbl_cartTile_pickUpToday: getLabelFromCopyOrFromTranslation(
        `global.cartItemTile.lbl_cartTile_pickUpToday`,
        globalCartItemTileLabels
      ),
    };
    this.quickViewLabels = getQuickViewLabelsCopy(qvLabelsObj);
    const { currentColorEntry } = this.state;
    const colorName = currentColorEntry && currentColorEntry.color && currentColorEntry.color.name;

    this.formValues = {
      Fit: '',
      Size: '',
      color: colorName,
      Quantity: 1,
    };
    this.filteredFitFromPDP = {};
    this.analyticsTriggered = false;
    this.imageSwatchesToDisplayHolder = [];
    this.newColorListHolder = [];
    this.apiConfig = getAPIConfig();
    this.isLowTier = isTier3Device();
    this.priceInfoAccessoryData = {};
    this.pdpProductDetails = {
      currentProduct: null,
    };
    this.loadBVScript = false;
    this.pdpDataInformation = {};
    this.willMonetateCarouselDisplay = TIER1;
    this.currentSelectedProductId = '';
    this.currentSelectedProductImage = '';
  }

  static getDerivedStateFromProps(props, state) {
    const {
      productInfo: { colorFitsSizesMap },
      formValues,
    } = props;
    const { color } = formValues || {};
    let currentColorEntry;
    if (color) {
      currentColorEntry = getMapSliceForColor(colorFitsSizesMap, color);
    } else {
      currentColorEntry = getMapSliceForColorProductId(
        colorFitsSizesMap,
        state.currentColorEntry.colorProductId
      );
    }
    return {
      ...state,
      currentColorEntry: currentColorEntry || {},
    };
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  componentDidMount() {
    if (window.BV) {
      this.setState({ showBazaarVoice: true });
    } else if (!this.isLowTier) {
      this.loadBVScript = true;
    }
    // kick off the polyfill for smooth scroll safari
    smoothscroll.polyfill();
    // Removing the previous value to handle the view more on backbutton
    setLocalStorage({ key: 'pdp1', value: 0 });
    setLocalStorage({ key: 'pdp2', value: 0 });

    window.onpopstate = this.onBackButton;

    const {
      productDetails,
      checkForOOSForVariant,
      isPlcc,
      getSocialProofData,
      productInfo,
      formValues,
      accessoriesData,
      allAccessories,
      isFromPLPPage,
      isFromSLPPage,
      router: {
        query: { isfromQuickView, recToken },
      },
      closeBirthdayModal,
      outfitV3WidgetVDABTestEnabled,
      outfitV3WidgetMnMABTest,
      outfitV3WidgetEnabled,
      setStyliticsProductTabListData,
      setSelectedProductIdForOutfit,
      additionalPromoModuleXContentId,
      fetchAdditionalPromoModule,
      additionalPromoModuleXContent,
      sendEventsToMonetateActn,
      fetchShippingAndReturnsModule,
      isShippedAndReturnsTabEnabled,
      shippingAndReturnsModuleXContentID,
      closeSimilarProductsModalActn,
      isSimilarProductsModalOpen,
    } = this.props;
    const { isBMModalOpen } = this.state;
    if (isBMModalOpen) closeBirthdayModal(false);

    const { customizationType } = accessoriesData || {};

    this.fetchShippingAndReturns(
      shippingAndReturnsModuleXContentID,
      isShippedAndReturnsTabEnabled,
      fetchShippingAndReturnsModule
    );

    if (isSimilarProductsModalOpen && typeof closeSimilarProductsModalActn === 'function') {
      closeSimilarProductsModalActn();
    }

    if (additionalPromoModuleXContentId && !additionalPromoModuleXContent) {
      fetchAdditionalPromoModule({
        contentId: additionalPromoModuleXContentId?.contentId,
      });
    }
    const { TCPStyleQTY, TCPStyleType, productFamily } = productInfo;
    const colorNameAvailable = formValues && formValues.color;
    const { currentProduct } = productDetails;
    this.setState({ hasMounted: true });
    const { productId, generalProductId } = currentProduct;

    this.pdpDataInformation = {
      TCPStyleQTY,
      TCPStyleType,
      color: { name: colorNameAvailable },
      productFamily,
    };
    const skuData = this.pdpDataInformation;
    const categoryId = this.getCatIdForRecommendation();
    const MONETATE_ENABLED = getMonetateEnabledFlag();
    const action = {
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.PDP,
      ...(productId && { itemPartNumber: productId }),
      categoryName: categoryId || '',
      excludedIds: '',
      provider: 'Monetate',
      reduxKey: Constants.RECOMMENDATIONS_PAGES_MAPPING.PDP,
      MONETATE_ENABLED,
      skuData,
      styleWithEligibility: false,
      isPlcc,
      outOfStock: checkForOOSForVariant,
    };

    action.reduxKey = action.page;

    if (customizationType === 'mandatory' && allAccessories?.length > 0) {
      this.setMinMaxPriceAccessories();
    }

    if (isFromPLPPage || isFromSLPPage) {
      this.getSizeNameFromFilters();
    }

    if (parseBoolean(isfromQuickView)) {
      this.initializeFormWithQuickViewSelectedValues();
    }
    markRUMTimings();
    if (outfitV3WidgetEnabled) {
      loadOutfitV3(
        generalProductId || productId,
        outfitV3WidgetVDABTestEnabled,
        outfitV3WidgetMnMABTest,
        setStyliticsProductTabListData,
        setSelectedProductIdForOutfit
      );
    }

    this.getPromotionPrice();

    sendMonetateEvents(recToken, sendEventsToMonetateActn);

    return window.addEventListener('load', getSocialProofData(action));
  }

  unlockBodyScroll = () => {
    document.body.classList.remove('stop-body-scroll');
    document.body.classList.remove('ReactModal__Body--open');
    document.body.style.overflow = '';
  };

  /*
  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(this.props, nextProps) && isEqual(this.state, nextState)) return false;
    return true;
  } */

  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  componentDidUpdate(prevProps) {
    const {
      isProductDataAvailable,
      accessoriesData,
      allAccessories,
      productInfoQV,
      productInfo: { colorFitsSizesMap, generalProductId, offerPrice },
      alternateBrand,
      dynamicContentPromo,
      formValues,
      closeSimilarProductsModalActn,
      isSimilarProductsModalOpen,
    } = this.props;
    const { isAnalyticsTriggered } = this.state;
    const { customizationType } = accessoriesData || {};
    const {
      productInfo: { generalProductId: prevGeneralProductId },
      productInfoQV: prevProductInfoQV,
    } = prevProps;

    if (
      prevGeneralProductId !== generalProductId &&
      isSimilarProductsModalOpen &&
      typeof closeSimilarProductsModalActn === 'function'
    ) {
      closeSimilarProductsModalActn();
    }

    if (
      prevGeneralProductId !== generalProductId &&
      productInfoQV &&
      !isEqual(prevProductInfoQV, productInfoQV)
    ) {
      this.triggerAnalytics();
      if (!isAnalyticsTriggered) {
        this.setState({ isAnalyticsTriggered: true });
      }

      this.state = {
        currentColorEntry:
          getMapSliceForColorProductId(
            colorFitsSizesMap,
            generalProductId?.replace(`$brand=${alternateBrand}`, '')
          ) || {},
        currentGiftCardValue: offerPrice,
        isDynamicComponentReady: dynamicContentPromo && dynamicContentPromo.length,
      };
      this.productChange();
      if (formValues && !isEqual(formValues, prevProps.formValues)) {
        const { color, fit, quantity, size } = formValues;
        this.onChangeSize(color, size, fit, quantity || 1);
        this.filteredFitFromPDP = {
          ...this.formValues,
        };
      }
    }

    /*
       Triggering Page load tracking on componentDidUpdate because we need to wait for the listPrice and
       it is triggered only in client side.
     */
    if (isProductDataAvailable && !isAnalyticsTriggered) {
      this.triggerAnalytics();
      this.willMonetateCarouselDisplay = isTier1Device();
      this.setState({ isAnalyticsTriggered: true });
    }
    if (
      customizationType === 'mandatory' &&
      prevProps.allAccessories !== allAccessories &&
      allAccessories.length > 0
    ) {
      this.setMinMaxPriceAccessories();
    }
  }

  // eslint-disable-next-line react/sort-comp
  productChange() {
    const {
      productDetails,
      productInfo,
      formValues,
      closeBirthdayModal,
      outfitV3WidgetVDABTestEnabled,
      outfitV3WidgetMnMABTest,
      outfitV3WidgetEnabled,
      setStyliticsProductTabListData,
      setSelectedProductIdForOutfit,
      additionalPromoModuleXContentId,
      fetchAdditionalPromoModule,
      additionalPromoModuleXContent,
    } = this.props;
    const { isBMModalOpen } = this.state;
    if (isBMModalOpen) closeBirthdayModal(false);
    if (additionalPromoModuleXContentId && !additionalPromoModuleXContent) {
      fetchAdditionalPromoModule({
        contentId: additionalPromoModuleXContentId?.contentId,
      });
    }
    const { TCPStyleQTY, TCPStyleType, productFamily } = productInfo;
    const colorNameAvailable = formValues && formValues.color;
    const { currentProduct } = productDetails;
    const { productId, generalProductId } = currentProduct;
    this.pdpDataInformation = {
      TCPStyleQTY,
      TCPStyleType,
      color: { name: colorNameAvailable },
      productFamily,
    };
    if (outfitV3WidgetEnabled) {
      loadOutfitV3(
        generalProductId || productId,
        outfitV3WidgetVDABTestEnabled,
        outfitV3WidgetMnMABTest,
        setStyliticsProductTabListData,
        setSelectedProductIdForOutfit
      );
    }
    this.getPromotionPrice();
  }

  componentWillUnmount() {
    setSessionStorage({ key: 'pdp_back', value: true });
  }

  fetchShippingAndReturns = (contentID, isEnabled, fetchFunction) => {
    if (contentID && isEnabled) {
      fetchFunction({
        contentId: contentID.contentId,
      });
    }
  };

  getPdpLabels = () => {
    const labelsObj1 = getLabelFromCopyOrFromTranslation(PdpSub, pdpLabels);
    const labelsObj2 = getLabelFromCopyOrFromTranslation('PLP.plpTiles', pdpLabels);
    const dynValue = getDynamicLabelValues('dynamic.browse_d.lbl_you_recently_viewed');
    const labelsObj3 = { lbl_you_recently_viewed: dynValue };
    const labelsObj4 = getLabelFromCopyOrFromTranslation('global.Sorting', pdpLabels);
    const labelsObj5 = getLabelFromCopyOrFromTranslation(CmnBrowse, pdpLabels);
    return { ...labelsObj1, ...labelsObj2, ...labelsObj3, ...labelsObj4, ...labelsObj5 };
  };

  getVariantNumber = (selectedProduct, formValue) => {
    if (!selectedProduct || !formValue) return null;

    const { size, fit } = formValue;

    const fitObj = selectedProduct.fits?.find((item) => item.fitName === (fit || ''));
    if (!fitObj) return null;

    const sizeObj = fitObj.sizes?.find((item) => item.sizeName === size);
    return sizeObj ? sizeObj.variantNo : null;
  };

  setPromotionPrice = (promotionPrice) => {
    const { promotionPrice: currentPromotionPrice } = this.state;
    if (promotionPrice !== currentPromotionPrice) this.setState({ promotionPrice });
  };

  extractPromotionPrice = () => {
    const { isShowPromoPriceMicroData, activePromotions, isUpdatedPromotionsDisplayEnabled } =
      this.props;
    const { currentColorEntry } = this.state;
    const { TCPPromotionPrice, TCPPromotionID } = currentColorEntry || {};

    try {
      if (isShowPromoPriceMicroData && activePromotions[TCPPromotionID] && TCPPromotionPrice) {
        const promo = createPromoArray({
          promotionsData: activePromotions,
          TCPPromotionID,
          TCPPromotionPrice,
          isUpdatedPromotionsDisplayEnabled,
        });
        if (Array.isArray(promo) && promo.length) {
          const promoMessage = promo[0].newPromotionMessage;
          const promoPrice = promoMessage?.price;
          if (promoPrice) {
            return promoPrice;
          }
          return null;
        }
        return null;
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  updatePickupSelectedAtProductDetail = (value) => {
    this.setState({
      isPickupSelectedAtProductDetail: value,
    });
  };

  handlePickupSelection = (param) => {
    if (this.updateDeliveryMethodSelection) {
      this.updateDeliveryMethodSelection(param);
    }
  };

  setMethod = (func) => {
    this.updateDeliveryMethodSelection = func;
  };

  getPromotionPrice = () => {
    const promotionPrice = this.extractPromotionPrice();
    this.setPromotionPrice(promotionPrice);
  };

  // scrollForCSR = () => {
  //   const { isPdpSsr } = this.props;
  //   if (!isPdpSsr) {
  //     this.scrollToBreadCrumbPDP();
  //   }
  // };

  initializeFormWithQuickViewSelectedValues = () => {
    const {
      router: {
        query: { fit = '', quantity = 1, size = '' },
      },
    } = this.props;
    this.formValues = {
      Fit: fit,
      Size: size,
      Quantity: parseInt(quantity, 10),
    };
    this.filteredFitFromPDP = {
      ...this.formValues,
    };
  };

  onBackButton = () => {
    const { router, closeBirthdayModal } = this.props;
    const { route } = router;
    const { isBMModalOpen } = this.state;
    if (
      route &&
      route.includes('ProductDetail') &&
      getSessionStorage('LAST_PAGE_PATH') === window.location.pathname
    ) {
      setSessionStorage({ key: 'pdp_back', value: true });
      if (getSessionStorage('LAST_PAGE_PATH').includes('home') && isBMModalOpen) {
        closeBirthdayModal(true);
      }
    } else {
      setSessionStorage({ key: 'LAST_PAGE_PATH', value: window.location.pathname });
      if (isBMModalOpen) closeBirthdayModal(false);
    }
  };

  setMinMaxPriceAccessories = () => {
    const { allAccessories } = this.props;
    const { maxOfferPrice, maxListPrice, minOfferPrice, minListPrice } =
      setMinMaxPrice(allAccessories);
    this.setState({
      minOfferPrice,
      maxOfferPrice,
      minListPrice,
      maxListPrice,
    });
  };

  getPriceInfoAccessoryPresent = () => {
    const { minOfferPrice, maxOfferPrice, minListPrice, maxListPrice } = this.state;

    this.priceInfoAccessoryData.minOfferPrice = minOfferPrice;
    this.priceInfoAccessoryData.maxOfferPrice = maxOfferPrice;
    this.priceInfoAccessoryData.minListPrice = minListPrice;
    this.priceInfoAccessoryData.maxListPrice = maxListPrice;

    return this.priceInfoAccessoryData;
  };

  /* Calls getSizeName, if from PLP or SLP page and filters are applied on PLP/SLP.
    - Checks currentColorEntry (Object) from state => fits (Array) => sizes(Array),
      - if sizeName found in sizes array and maxAvailable > 0 sets Size and Fit in this.formValues
  */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  getSizeNameFromFilters = () => {
    const { isFromPLPPage, isFromSLPPage, appliedFiltersPLP, appliedFiltersSLP } = this.props;
    const { currentColorEntry } = this.state;
    let appliedFilters;
    if (isFromPLPPage) {
      appliedFilters = appliedFiltersPLP;
    }
    if (isFromSLPPage) {
      appliedFilters = appliedFiltersSLP;
    }

    const {
      v_tcpsize_uFilter: sizeNameArr,
      v_clothingsize_uFilter: clothingSizeNameArr,
      v_shoessize_uFilter: shoeSizeNameArr,
      v_accessoriessize_uFilter: accessoriesSizeNameArr,
      v_tcpfit_unbxd_uFilter: selectedFit = [],
    } = appliedFilters || {};
    if (sizeNameArr) {
      if (!sizeNameArr || sizeNameArr.toString() === '') {
        return;
      }
      this.getSizeName(sizeNameArr, currentColorEntry);
    }

    if (clothingSizeNameArr) {
      if (!clothingSizeNameArr || clothingSizeNameArr.toString() === '') {
        return;
      }
      this.getCategoricalSizeIfExistsInFits(
        clothingSizeNameArr,
        currentColorEntry,
        'v_clothingsize_uFilter',
        selectedFit[0]
      );
    }

    if (shoeSizeNameArr) {
      if (!shoeSizeNameArr || shoeSizeNameArr.toString() === '') {
        return;
      }
      this.getCategoricalSizeIfExistsInFits(
        shoeSizeNameArr,
        currentColorEntry,
        'v_shoessize_uFilter',
        selectedFit[0]
      );
    }

    if (accessoriesSizeNameArr) {
      if (!accessoriesSizeNameArr || accessoriesSizeNameArr.toString() === '') {
        return;
      }
      this.getCategoricalSizeIfExistsInFits(
        accessoriesSizeNameArr,
        currentColorEntry,
        'v_accessoriessize_uFilter',
        selectedFit[0]
      );
    }
  };

  /**
   * Get the sizeName if it exists in fits of currentColor entry object and set Size and Fit in this.formValues.
   * @param {Array} filterSizeNames
   * @param {Object} currentColorEntry
   */
  getSizeIfExistsInFits = (filterSizeNames, currentColorEntry) => {
    const { fits } = currentColorEntry;

    fits.some((fit) => {
      const { fitName, sizes } = fit;
      const foundSize = sizes.find(
        (size) => filterSizeNames.includes(size.sizeName) && size.maxAvailable > 0
      );
      if (foundSize) {
        this.formValues = {
          ...this.formValues,
          Fit: fitName,
          Size: foundSize.sizeName,
        };
        return true;
      }
      return false;
    });
  };

  getCategoricalSizeIfExistsInFits = (
    filterSizeNames,
    currentColorEntry,
    filterNameKey,
    selectedFit = ''
  ) => {
    const sizeGroupKeyMap = {
      v_clothingsize_uFilter: 'clothingSize',
      v_shoessize_uFilter: 'shoesSize',
      v_accessoriessize_uFilter: 'accessoriesSize',
    };
    const { fits } = currentColorEntry;

    // eslint-disable-next-line sonarjs/cognitive-complexity
    fits.some((fit) => {
      const { fitName, sizes } = fit;
      if (
        (selectedFit && fitName && selectedFit?.toLowerCase() === fitName?.toLowerCase()) ||
        (fitName && !selectedFit) ||
        (selectedFit && !fitName) ||
        (!selectedFit && !fitName)
      ) {
        const foundSize = sizes.find((size) =>
          filterSizeNames.some((filterSizeName) => {
            const newSizeName = size[sizeGroupKeyMap[filterNameKey]];
            let temp;
            if (!Array.isArray(newSizeName) && newSizeName?.indexOf(';') > -1) {
              temp = newSizeName.split(';');
            }
            temp = newSizeName;
            if (Array.isArray(temp)) {
              return temp.some((ele) => ele.toLowerCase() === filterSizeName.toLowerCase());
            }
            return temp?.toLowerCase() === filterSizeName.toLowerCase();
          })
        );
        if (foundSize) {
          this.formValues = {
            ...this.formValues,
            Fit: fitName,
            Size: foundSize.sizeName,
          };
          return true;
        }
      }
      return false;
    });
  };

  /**
   * Calls getSizeIfExistsInFits which will set Size and Fit in this.formValue when filtered size name is found in the sizes array, if the sizeNamerArr length is greater then 0.
   * @param {Array} sizeNameArr
   * @param {Object} currentColorEntry
   */
  getSizeName = (sizeNameArr, currentColorEntry) => {
    if (sizeNameArr?.length > 0) {
      const filterSizeNames = sizeNameArr.map((name) => name.split('_')[1]);
      this.getSizeIfExistsInFits(filterSizeNames, currentColorEntry);
    }
  };

  sendAdobePageViewEvent = (pageData, User, APIConfig, session) => {
    return new Promise((resolve) => {
      pushEventToAdobeAnalytics('page_view', { pageData, User, APIConfig, session });
      resolve();
    });
  };

  // eslint-disable-next-line complexity
  triggerAnalytics = () => {
    const {
      productInfo,
      trackPageLoad,
      router,
      router: {
        query: { isSearchPage, viaModule, imageSearch, recommendationCarousel },
      },
      navigateType,
      storeId,
      currency,
      accessoriesData,
      pageData,
      User,
      APIConfig,
      session,
    } = this.props;
    const { customizationType } = accessoriesData || {};
    const icid = getIcidValue(router.asPath);
    const isSearchPageFlag = isSearchPage === 'true';
    const { currentColorEntry } = this.state;
    const selectedColorProductId = currentColorEntry?.colorProductId;
    const productsFormatted = this.formatProductsData(
      productInfo,
      isSearchPageFlag,
      selectedColorProductId,
      viaModule
    );

    const formatProductDataForEE = this.formatProductsDataForEE(
      productInfo,
      isSearchPageFlag,
      selectedColorProductId,
      currency
    );
    const { name, ratingsProductId, generalProductId } = productInfo;
    const nameParam = name?.toLowerCase();
    const pageName = `product:${ratingsProductId}:${nameParam}`;
    let customEvents = ['prodView', 'event1', 'event80', 'event93'];
    const productId = generalProductId ? generalProductId.split('_')[0] : '';
    const localSearchType = router?.query?.searchType;
    let localListingCount = '';
    let localPageSearchText = '';

    let additionalData = {};

    if (isSearchPageFlag) {
      customEvents.push('event83');
    } else if (imageSearch) {
      customEvents = ['prodView', 'event1', 'event80'];
    } else if (viaModule === RECOMMENDATION) {
      customEvents = ['prodView', 'event1', 'event80', names.eVarPropEvent.event50];
      pushEventToAdobeAnalytics('cross_sell_clicks', recommendationCarousel);
      additionalData = {
        internalCampaignId: '',
        pageSection: '',
        searchTerm: '',
        storeId,
        searchType: '', // evar59 or cd59
        listingCount: '', // evar27 or cd27
        pageSearchText: '', // evar26 or cd26
        customEvents: [...customEvents, 'event20'],
      };
    } else if (icid) {
      additionalData.internalCampaignId = icid;
      additionalData.pageNavigationText = '';
    }

    if (customizationType?.length) {
      additionalData.backpack_metrics31 = 1;
      additionalData.backpack_cd11 = customizationType;
    }

    if (navigateType === 'direct') {
      customEvents = ['prodView', 'event1', 'event80', 'event93', 'event100', 'event20'];
    }
    const ImageSearchTypes = [
      ANALYTICS_CONSTANTS.featuredProducts,
      ANALYTICS_CONSTANTS.topMatchingProducts,
      ANALYTICS_CONSTANTS.previousProducts,
    ];

    const isPresentInSearchTypes = ImageSearchTypes.includes(localSearchType);
    if (isPresentInSearchTypes) {
      localListingCount = 'Zero';
      localPageSearchText = pageName?.split(':')[2];
    }

    const trackPayload = {
      pageType: 'product',
      pageName,
      searchType: localSearchType,
      pageSection: 'product',
      pageSubSection: 'product',
      products: productsFormatted,
      customEvents: [...customEvents, isPresentInSearchTypes && 'event20'],
      productId,
      listingCount: localListingCount,
      pageSearchText: localPageSearchText,
      ...additionalData,
    };

    if (isSearchPageFlag) {
      trackPayload.pageNavigationText = '';
    }

    if (productsFormatted) {
      trackPageLoad(trackPayload);
    }

    if (formatProductDataForEE) {
      fireEnhancedEcomm({
        eventName: 'productDetail',
        productsObj: formatProductDataForEE,
        eventType: 'detail',
        pageName: getGAPageName(),
        currCode: currency,
        eventLabel: 'pdp product detail',
      });
    }
    const prodObjForAA = { ...productInfo, ...formatProductDataForEE?.[0] };
    pageData.pageName = `pdp:${router?.asPath?.split('/p/')?.[1]}`;
    this.sendAdobePageViewEvent(pageData, User, APIConfig, session).then(() => {
      pushEventToAdobeAnalytics('product_detail', prodObjForAA);
    });
  };

  handleDynamicComponentLoad = () => {
    this.setState({ isDynamicComponentReady: true });
  };

  getCD92 = (recommendationCarousel, recsObj) => {
    let cd92 = recommendationCarousel ? `${DIMENSION92_TEXT}${recommendationCarousel}` : null;

    if (!cd92 && recsObj && recsObj.dimension92) {
      cd92 = recsObj.dimension92;
    }
    return cd92;
  };

  getDimension158 = ({
    product,
    initialColorConsolidationMultipackMapping,
    selectedColorProductId,
    color,
    isColorConsolidationEnabled,
    isTakeDownRedirectionEnabled,
    isTakeDownProduct,
    renderedPid,
    takeDownCategory,
  }) => {
    let cd158 = '';
    const colorInfo = color?.split('-')?.[0];
    const isColorConsolidatedProduct =
      product.allProductId?.find((item) => item.productid === selectedColorProductId)
        ?.color_consolidated_product ||
      initialColorConsolidationMultipackMapping?.includes(selectedColorProductId) ||
      false;
    if (isColorConsolidationEnabled && isColorConsolidatedProduct && !isTakeDownProduct) {
      cd158 = `${product.generalProductId}>COLOR|${colorInfo}|${selectedColorProductId}`;
    }
    if (isTakeDownRedirectionEnabled && isTakeDownProduct) {
      if (isColorConsolidatedProduct) {
        cd158 = `${renderedPid}>ALSO AVAILABLE IN|${takeDownCategory}|COLOR|${colorInfo}|${selectedColorProductId}`;
      } else {
        cd158 = `${renderedPid}>ALSO AVAILABLE IN|${takeDownCategory}|${selectedColorProductId}`;
      }
    }
    return cd158;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getIsTopRatedOrBestSellerAnalytics = ({ type }) => {
    const {
      breadCrumbs,
      currentCategoryIdPLP,
      isTopRatedBadgeEnabled,
      isBestSellerBackAbEnabled,
      isMostFavoritedBadgeEnabled,
      isFromPLPPage,
      router: {
        query: { isSearchPage },
      },
    } = this.props;
    const { currentColorEntry } = this.state;

    if (
      (!isTopRatedBadgeEnabled || !isBestSellerBackAbEnabled || !isMostFavoritedBadgeEnabled) &&
      isFromPLPPage &&
      !parseBoolean(isSearchPage) &&
      breadCrumbs.length > 1
    ) {
      const badge1 = currentColorEntry?.miscInfo?.badge1;
      const isTopRated = getTopRatedBadge(badge1, true, currentCategoryIdPLP);
      const isBestSeller = getBestSellerBadge(badge1, true, currentCategoryIdPLP);

      const isMostFavorite = getMostFavoriteBadge(badge1, true, currentCategoryIdPLP);
      if (!isTopRatedBadgeEnabled && type === TOP_RATED) {
        return isTopRated ? TOP_RATED_ANALYTICS_STRING : '';
      }

      if (!isBestSellerBackAbEnabled && type === BEST_SELLER) {
        return isBestSeller ? BEST_SELLER_ANALYTICS_STRING : '';
      }
      if (!isMostFavoritedBadgeEnabled && type === MOST_FAVORITED) {
        return isMostFavorite ? MOST_FAVORITED_ANALYTICS_STRING : '';
      }
    }
    return '';
  };

  getNullSearchAnalyticsString = ({ isSearchPage, alternateBrand, prodBrand }) => {
    const {
      router: {
        query: { isFromSearchPageQV },
      },
    } = this.props;
    return (isSearchPage || isFromSearchPageQV) && alternateBrand
      ? { dimension122: `${prodBrand}>${alternateBrand.toUpperCase()}|null search` }
      : '';
  };

  getDimension66 = () => {
    let params;
    if (typeof window !== 'undefined') {
      params = new URLSearchParams(window.location.search);
    }
    const queryParams = params?.get('fromBIA');
    const cd66 = JSON.parse(getSessionStorage('biaDimension'))?.dimension66;
    return queryParams && cd66 ? cd66 : '';
  };

  // eslint-disable-next-line complexity
  formatProductsDataForEE = (product, isSearchPage, selectedColorProductId, currency) => {
    const productData = [];
    const { isGiftCard, colorFitsSizesMap, categoryPathMap, categoryId } = product;
    const {
      searchedText = '',
      isColorConsolidationEnabled,
      initialColorConsolidationMultipackMapping,
      isTakeDownRedirectionEnabled,
      isTakeDownProduct,
      renderedPid,
      takeDownCategory,
      alternateBrand,
      isESGBadgePDPBackABEnabled,
      productInfo: { allProductId },
      isHideOriginalPriceAndMarchantTagEnabled,
      router: {
        query: { viaModule, recommendationCarousel },
      },
      activePromotions,
    } = this.props;
    const { currentColorEntry } = this.state;
    const features = getFeatures(colorFitsSizesMap, selectedColorProductId, isGiftCard);
    const recsObj = this.getRecsObject(product);
    const color =
      (product &&
        product.colorFitsSizesMap &&
        product.colorFitsSizesMap
          .filter((productTile) => {
            return productTile.colorProductId === selectedColorProductId;
          })
          .map((productTile) => productTile.color.name)
          .join('')) ||
      '';
    const prodBrand = getBrand().toUpperCase();
    let type = '';
    if (
      viaModule &&
      viaModule.toLowerCase() === 'recommendation' &&
      recsObj &&
      recsObj.dimension92
    ) {
      type = recsObj.dimension92;
    } else if (searchedText) {
      type = `search-${searchedText}`;
    } else {
      const exactCategoryPath =
        (categoryId &&
          categoryPathMap?.filter((categoryPath) => categoryPath.includes(categoryId))) ||
        '';
      type = (exactCategoryPath && getCategoryIdAndName(exactCategoryPath)) || '';
    }

    const cd92 = this.getCD92(recommendationCarousel, recsObj);

    const cd158 =
      this.getDimension158({
        product,
        initialColorConsolidationMultipackMapping,
        selectedColorProductId,
        color,
        isColorConsolidationEnabled,
        isTakeDownRedirectionEnabled,
        isTakeDownProduct,
        renderedPid,
        takeDownCategory,
      }) || '';

    const cd122 = this.getNullSearchAnalyticsString({ isSearchPage, alternateBrand, prodBrand });

    const cd66 = this.getDimension66();
    const cd108 = this.getIsTopRatedOrBestSellerAnalytics({ type: TOP_RATED });
    const cd109 = this.getIsTopRatedOrBestSellerAnalytics({ type: BEST_SELLER });
    const cd139 = this.getIsTopRatedOrBestSellerAnalytics({ type: MOST_FAVORITED });
    const cd135 = getIsESGBadgeAnalyticsString({
      backAB: isESGBadgePDPBackABEnabled,
      allProductId,
      colorDisplayId: selectedColorProductId,
    });
    const originalPrice = getOriginalPrice({
      hardMarkDown: currentColorEntry?.hardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled,
      listPrice: product?.listPrice,
      currency,
    });

    productData.push({
      id: product.generalProductId,
      variant: color,
      category: type,
      brand: prodBrand,
      price: product.listPrice,
      metric1: '1',
      metric93: '1',
      dimension35: prodBrand,
      dimension89: product.generalProductId,
      dimension77: color,
      dimension72: features,
      dimension67: product.offerPrice < product.listPrice ? 'on sale' : 'full price',
      dimension66: cd66,
      dimension63: `${product.offerPrice}${currency} ${originalPrice}`,
      dimension2: getDimension2Value(cd92) || 'browse',
      dimension56: activePromotions[currentColorEntry?.TCPPromotionID]
        ? formatPromotionMessage(activePromotions, currentColorEntry?.TCPPromotionID)
        : '',
      dimension11: product?.accessoriesData?.customizationType || '',
      dimension158: cd158,
      dimension108: cd108,
      dimension109: cd109,
      dimension135: cd135,
      dimension139: cd139,
      ...recsObj,
      ...cd122,
    });
    return productData;
  };

  handleRatingClick = (value) => {
    this.setState({ starRatingClicked: value });
  };

  formatProductsData = (product, isSearchPage, selectedColorProductId, viaModule) => {
    const productData = [];
    const color =
      (product &&
        product.colorFitsSizesMap &&
        product.colorFitsSizesMap
          .filter((productTile) => {
            return productTile.colorProductId === selectedColorProductId;
          })
          .map((productTile) => productTile.color.name)
          .join('')) ||
      '';
    const { isGiftCard, colorFitsSizesMap } = product;
    const selectedColorElement = this.getSelectedColorData(
      colorFitsSizesMap,
      selectedColorProductId
    );
    const hasFits =
      selectedColorElement && selectedColorElement[0] && selectedColorElement[0].hasFits;

    let features = '';

    if (!isGiftCard) {
      features += 'alt images full size image';
    }
    if (hasFits) {
      features += `${features} size chart`;
    }

    const productId = product.generalProductId.split('_')[0];
    productData.push({
      colorId: product.generalProductId,
      color,
      id: productId,
      price: product.listPrice,
      extPrice: product.listPrice,
      listPrice: product.listPrice,
      pricingState: product.offerPrice < product.listPrice ? 'on sale' : 'full price',
      rating: product.ratings,
      reviews: product.reviewsCount,
      plpClick: (viaModule !== RECOMMENDATION).toString(),
      searchClick: isSearchPage,
      features,
      ...this.getRecsObject(product),
    });
    return productData;
  };

  formatOutfitProductsData = (products) => {
    return products.map((tile) => {
      return {
        id: tile.id,
        stylitics: 'true',
        uniqueOutfitId: tile.id,
        outfitId: tile.id,
      };
    });
  };

  triggerStylyticsAnalytics = (items) => {
    const { productInfo, trackClick } = this.props;
    const { name, ratingsProductId } = productInfo;
    const nameParam = name && name.toLowerCase();
    const pageName = `product:${ratingsProductId}:${nameParam}`;
    const productsFormatted = this.formatOutfitProductsData(items);
    const trackPayload = {
      pageType: 'product',
      pageName,
      pageSection: 'product',
      pageSubSection: 'product',
      products: productsFormatted,
      customEvents: ['event74', 'event76', 'event95'],
      pageNavigationText: '',
    };
    if (!this.analyticsTriggered && productsFormatted) {
      trackClick(trackPayload);
      this.analyticsTriggered = true;
    }
  };

  get404PageType = (recIdenFor404Page) => {
    const brand = getBrand();
    if (recIdenFor404Page) return `${brand}_404_page`;
    return '';
  };

  getRecsObject = (product) => {
    const {
      router,
      router: {
        query: { viaModule, viaPage, productCrossSellDriver },
      },
    } = this.props;
    let recIdenFrom404Page = '';
    if (router.asPath.split('?').length > 0)
      recIdenFrom404Page = getParam('recommendationSource', router.asPath.split('?')[1]);
    const page404Type = this.get404PageType(recIdenFrom404Page);
    if (viaModule === RECOMMENDATION || recIdenFrom404Page) {
      return {
        dimension20: product.unbxdProdId,
        dimension21: recIdenFrom404Page ? page404Type : viaPage,
        dimension92: productCrossSellDriver,
        metric50: '1',
        productCrossSellDriver,
      };
    }
    return null;
  };

  getSelectedColorData = (colorFitsSizesMap, colorId) => {
    return (
      colorFitsSizesMap &&
      colorFitsSizesMap.filter((colorItem) => {
        return colorItem.colorProductId === colorId;
      })
    );
  };

  checkSizeAvailability = (currentColorEntry, size) => {
    // Check if the object has 'fits' property and it's an array with at least one entry
    if (
      currentColorEntry.fits &&
      Array.isArray(currentColorEntry.fits) &&
      currentColorEntry.fits.length > 0
    ) {
      // Get the first entry in the 'fits' array
      const firstFit = currentColorEntry.fits[0];
      // Check if the firstFit has 'sizes' property and it's an array with at least one entry
      if (firstFit.sizes && Array.isArray(firstFit.sizes) && firstFit.sizes.length > 0) {
        // Find the matching size or return the first available size name
        const availableSize = firstFit.sizes.find((entry) => entry.sizeName === size);
        return availableSize ? size : null;
      }
    }
    // If fits property or sizes array is missing or empty, return null
    return null;
  };

  onChangeColor = (e, selectedSize, selectedFit, selectedQuantity) => {
    const {
      productInfo: { colorFitsSizesMap, allProductId, isGiftCard },
      productInfo,
      router: {
        query: { isSearchPage },
      },
      trackClick,
      currency,
      isColorConsolidationEnabled,
      initialColorConsolidationMultipackMapping,
    } = this.props;
    const { currentGiftCardValue } = this.state;
    let sizeUpdate;
    const currentColorEntryUpdate = getMapSliceForColor(colorFitsSizesMap, e);
    if (isGiftCard && selectedSize && currentColorEntryUpdate) {
      sizeUpdate = this.checkSizeAvailability(currentColorEntryUpdate, selectedSize);
    }
    const currentGiftCardValueUpdate =
      sizeUpdate ||
      (currentColorEntryUpdate && currentColorEntryUpdate.offerPrice) ||
      currentGiftCardValue;
    this.setState({
      currentColorEntry: currentColorEntryUpdate,
      renderReceiveProps: true,
      currentGiftCardValue: currentGiftCardValueUpdate,
    });
    this.formValues = {
      Fit: selectedFit,
      Size: sizeUpdate || selectedSize,
      color: e,
      Quantity: selectedQuantity,
    };
    const colorProductId = getMapSliceForColor(colorFitsSizesMap, e)?.colorProductId;
    if (isColorConsolidationEnabled) {
      const isColorConsolidatedProduct =
        allProductId?.find((product) => product.productid === colorProductId)
          ?.color_consolidated_product ||
        initialColorConsolidationMultipackMapping.includes(colorProductId) ||
        false;

      if (isColorConsolidatedProduct) {
        const colorInfo = e?.split('-')?.[0];

        const isSearchPageFlag = isSearchPage === 'true';
        const formatProductDataForEE = this.formatProductsDataForEE(
          productInfo,
          isSearchPageFlag,
          colorProductId,
          currency
        );
        trackClick({
          color_consolidation_cd157: `${colorProductId}|${colorInfo}`,
          color_consolidation_metrics104: '1',
          customEvents: ['event104'],
        });
        if (formatProductDataForEE) {
          fireEnhancedEcomm({
            eventName: 'productDetail',
            productsObj: formatProductDataForEE,
            eventType: 'detail',
            pageName: getGAPageName(),
            currCode: currency,
            eventLabel: 'pdp product detail',
          });
        }
      }
    }
  };

  onChangeSize = (selectedColor, e, selectedFit, selectedQuantity) => {
    this.setState({ currentGiftCardValue: e });
    this.formValues = {
      Fit: selectedFit,
      Size: e,
      color: selectedColor,
      Quantity: selectedQuantity,
    };
  };

  handleSimilarProductsModalToggle = (e) => {
    const {
      openSimilarProductsModalActn,
      closeSimilarProductsModalActn,
      isSimilarProductsModalOpen,
    } = this.props;
    e?.preventDefault();
    if (isSimilarProductsModalOpen) {
      closeSimilarProductsModalActn();
    } else {
      openSimilarProductsModalActn();
    }
  };

  updateQuantityChange = (selectedQuantity) => {
    this.formValues = {
      ...this.formValues,
      Quantity: selectedQuantity,
    };
  };

  onGoBack = (e) => {
    const { isDefaultBreadCrumb } = this.props;
    if (isDefaultBreadCrumb) {
      e.preventDefault();
      routerPush('/', '/home');
    }
    this.triggerBack(e);
  };

  triggerBack = (e) => {
    e.preventDefault();
    if (window.history.length > 2) window.history.back();
  };

  getProductSummary = ({
    keepAlive,
    handleMetaProps,
    isInWishList,
    shouldRenderPriceOnly,
    zoneOneBadges,
    promotionPrice,
    additionalClassName = '',
    promoPriceForStoreSpecial,
    isShowNonH1Title,
  }) => {
    const {
      productDetails,
      productInfo,
      currency,
      currencyAttributes,
      onAddItemToFavorites,
      isLoggedIn,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      isLoading,
      wishList,
      hidePriceDisplay,
      isPerUnitPriceEnabled,
      isBrierleyPromoEnabled,
      onSetLastDeletedItemIdAction,
      productInfo: { TCPStyleQTY },
      deleteFavItemInProgressFlag,
      checkForOOSForVariant,
      isShowBrandNameEnabled,
      alternateBrand,
      openModal,
      formValues,
      accessories,
      secondarySelectedAccessoryList,
      allAccessories,
      setProductDataForReviewActn,
      isHideOriginalPriceAndMarchantTagEnabled,
      currentProduct,
      isPlccPriceOnPDP,
      isPixleeWidget,
      isPDPRedesignEnabled,
      setPdpTabSectionIndex,
      plccOfferPercentage,
      storeSpecialDiscount,
      activePromotions,
      defaultStoreId,
      storeSpecialList,
      isClickableBrandBadgesEnabled,
      isFinalSaleMessageEnabled,
      ...otherProps
    } = this.props;
    const { isPlcc } = otherProps;
    const {
      currentGiftCardValue,
      currentColorEntry,
      showBazaarVoice,
      isPickupSelectedAtProductDetail,
    } = this.state;
    const { colorDisplayId, colorProductId, hardMarkDown, storeSpecials } = currentColorEntry || {};
    const getGiftCardValue = currentGiftCardValue || productInfo.offerPrice;
    const { isGiftCard, primaryBrand } = productInfo;
    const {
      currentProduct: { ratings, reviewsCount },
    } = productDetails;
    const priceInfoAccessoryPresent = this.getPriceInfoAccessoryPresent();
    const { minOfferPrice, maxOfferPrice, minListPrice, maxListPrice } = this.state;
    const isAccessoryPresentMandatory = getIsAccessoryPresentMandatory(
      minOfferPrice,
      maxOfferPrice,
      minListPrice,
      maxListPrice
    );
    const isHideOriginalPrice = hideProductOriginalPrice(
      hardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled
    );
    const colorProduct =
      getMapSliceForColorProductId(productInfo.colorFitsSizesMap, colorProductId) || {};
    const wrapperCls =
      isPDPRedesignEnabled && !shouldRenderPriceOnly
        ? 'product-summary-wrapper pdp-redesigned'
        : 'product-summary-wrapper';
    return (
      <div className={`${wrapperCls}${additionalClassName}`}>
        <Product
          {...otherProps}
          isGiftCard={isGiftCard}
          productDetails={productDetails}
          currencySymbol={currency}
          selectedColorProductId={colorProductId}
          currencyAttributes={currencyAttributes}
          onAddItemToFavorites={onAddItemToFavorites}
          isLoggedIn={isLoggedIn}
          keepAlive={keepAlive}
          className="hide-on-mobile"
          AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
          removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
          isLoading={isLoading}
          isInWishList={isInWishList}
          isHasPlcc={isPlcc}
          hidePriceDisplay={hidePriceDisplay}
          isPerUnitPriceEnabled={isPerUnitPriceEnabled}
          isBrierleyPromoEnabled={isBrierleyPromoEnabled}
          TCPStyleQTY={TCPStyleQTY}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          wishList={wishList}
          deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
          isAfterPayDisplay={!checkForOOSForVariant}
          isOutfitPage={false}
          colorDisplayId={colorDisplayId}
          primaryBrand={primaryBrand}
          isShowBrandNameEnabled={isShowBrandNameEnabled}
          openModal={openModal}
          alternateBrand={alternateBrand}
          formValues={formValues || this.formValues}
          handleRatingClick={this.handleRatingClick}
          isAccessoryPresentMandatory={isAccessoryPresentMandatory}
          priceInfoAccessoryPresent={priceInfoAccessoryPresent}
          accessories={accessories}
          secondarySelectedAccessoryList={secondarySelectedAccessoryList}
          setProductDataForReviewActn={setProductDataForReviewActn}
          isHideOriginalPrice={isHideOriginalPrice}
          isPlccPriceOnPDP={isPlccPriceOnPDP}
          isPDPRedesignEnabled={isPDPRedesignEnabled}
          productMiscInfo={colorProduct}
          shouldRenderPriceOnly={shouldRenderPriceOnly}
          zoneOneBadges={zoneOneBadges}
          setPdpTabSectionIndex={setPdpTabSectionIndex}
          promotionPrice={promotionPrice}
          setPromotionPrice={this.setPromotionPrice}
          isPDP
          plccOfferPercentage={plccOfferPercentage}
          storeSpecialDiscount={storeSpecialDiscount}
          isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
          storeSpecials={storeSpecials}
          promoPriceForStoreSpecial={promoPriceForStoreSpecial}
          activePromotions={activePromotions}
          defaultStoreId={defaultStoreId}
          storeSpecialList={storeSpecialList}
          isShowNonH1Title={isShowNonH1Title}
          isClickableBrandBadgesEnabled={isClickableBrandBadgesEnabled}
          isFinalSaleMessageEnabled={isFinalSaleMessageEnabled}
        />
        {/* As BazaarVoice renders in CSR only so added below meta tags to add aggregateRating(BazaarVoice) SEO data in page */}
        {!isPixleeWidget && showBazaarVoice && ratings > 0 && reviewsCount > 0 && handleMetaProps && (
          <script
            type="application/ld+json"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(this.getAggregateRatings(ratings, reviewsCount)),
            }}
          />
        )}
        {isGiftCard && (!isPDPRedesignEnabled || shouldRenderPriceOnly) ? (
          <div
            className={`${
              shouldRenderPriceOnly ? ' pdp-redesign-gift-card-price' : 'product-price-desktop-view'
            }`}
          >
            {isLoading ? (
              <LoaderSkelton />
            ) : (
              <ProductPrice
                offerPrice={parseInt(getGiftCardValue, 10)}
                listPrice={parseInt(getGiftCardValue, 10)}
                hideItemProp // prop is used to hide unwanted duplicate itemProp as we have duplicate ProductPrice component for web and mobile on PDP pages
                currencySymbol={currency}
                currencyAttributes={currencyAttributes}
                isGiftCard={isGiftCard}
                isPlcc={isPlcc}
                isPerUnitPriceEnabled={isPerUnitPriceEnabled}
                TCPStyleQTY={TCPStyleQTY}
                wishList={wishList}
                isAfterPayDisplay
                isHideOriginalPrice={isHideOriginalPrice}
                colorProductId={colorProductId}
                isPDPRedesignPrice={shouldRenderPriceOnly}
                zoneOneBadges={zoneOneBadges}
                colorProduct={colorProduct}
              />
            )}
          </div>
        ) : null}
      </div>
    );
  };

  getAggregateRatings = (ratings, reviewsCount) => {
    return {
      '@context': 'http://schema.org',
      '@type': 'Product',
      name: 'Product',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: ratings,
        bestRating: '5',
        reviewCount: reviewsCount,
      },
    };
  };

  getSeoData = (
    productDetails,
    currentColorEntry,
    currency,
    checkForOOSForVariant,
    imgForSeo,
    asPath,
    promotionPrice
  ) => {
    const { currentProduct } = productDetails;
    const variantsSeoData = getVariantsForSeo(currentProduct, currency);
    const currentHost = getHost();
    const urlValue = `${currentHost}${asPath}`;
    const availabilityUrl = 'http://schema.org/';
    const {
      primaryBrand,
      name,
      product_long_description: longDesc,
      auxDescription,
      isGiftCard,
      ratings = 0,
      reviewsCount = 0,
    } = currentProduct || {};
    const colorName = changeOnlyFirstLetterToCapital(
      currentColorEntry?.color?.family || auxDescription
    );
    const titleText = auxDescription && !isGiftCard ? `${name} - ${colorName}` : name;
    const [productGroupID] = currentColorEntry?.colorProductId?.split('_') || [];
    return {
      '@context': availabilityUrl,
      '@type': `${variantsSeoData?.length > 0 ? 'ProductGroup' : 'Product'}`,
      name: titleText,
      brand: getPdpBrandLabel({ primaryBrand }),
      productId: currentColorEntry?.colorProductId,
      description: longDesc,
      color: colorName,
      isFamilyFriendly: true,
      image: imgForSeo,
      offers: {
        '@type': 'Offer',
        availability: checkForOOSForVariant
          ? `${availabilityUrl}OutOfStock`
          : `${availabilityUrl}InStock`,
        itemCondition: `${availabilityUrl}NewCondition`,
        priceCurrency: currency,
        price: promotionPrice || currentColorEntry?.offerPrice,
        url: urlValue,
        priceValidUntil: formatDateFromDay(),
      },
      variesBy: ['https://schema.org/color'],
      productGroupID,
      hasVariant: [...variantsSeoData],
      ...(ratings > 0 && reviewsCount > 0
        ? {
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: ratings || '4.5',
              bestRating: '5',
              reviewCount: reviewsCount || '120',
              worstRating: '1',
            },
          }
        : {
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.5',
              bestRating: '5',
              reviewCount: '120',
              worstRating: '1',
            },
          }),
    };
  };

  getBackButton = (buttonText, backAction) => {
    return (
      <div className="go-back-container">
        <button type="button" onClick={backAction} className="button-go-back">
          <Image src={getIconPath('medium-left-arrow')} alt="" />
          <BodyCopy className="back-button" fontFamily="secondary" fontSize="fs16">
            {buttonText}
          </BodyCopy>
        </button>
      </div>
    );
  };

  getBreadCrumb = () => {
    const {
      breadCrumbs,
      router: {
        query: { isSearchPage },
      },
    } = this.props;
    if (parseBoolean(isSearchPage)) {
      return this.getBackButton(
        renderLabel(this.pdpLabel.lbl_back_to_results, 'lbl_back_to_results'),
        this.triggerBack
      );
    }
    if (breadCrumbs) {
      return <FixedBreadCrumbs crumbs={breadCrumbs} separationChar=">" isPDPPage />;
    }
    return null;
  };

  getIsTopRatedOrBestSellerBadge = ({ badge1, currentCategoryIdPLP, badgeSLP, callback }) => {
    const {
      isFromPLPPage,
      router: {
        query: { isSearchPage },
      },
    } = this.props;
    if (!parseBoolean(isSearchPage) && isFromPLPPage && callback) {
      return callback(badge1, true, currentCategoryIdPLP);
    }
    if (parseBoolean(isSearchPage) && badgeSLP) {
      return true;
    }
    return false;
  };

  getTopBadge = ({ isTopRated, isBestSeller, link }) => {
    const {
      breadCrumbs,
      isFromPLPPage,
      router: {
        query: { isSearchPage },
      },
      isTopRatedBadgeEnabled,
      isBestSellerBackAbEnabled,
      isTopRatedBadgeEnabledSLP,
      sortByRatingLabel,
      isBestSellerBadgeEnabledSLP,
    } = this.props;
    const { lbl_TCPBazaarVoiceRating: topRatedBadgeLabel, lbl_best_seller: bestSellerBadgeLabel } =
      this.pdpLabel;
    if (!parseBoolean(isSearchPage) && isFromPLPPage && breadCrumbs.length > 1) {
      return (
        <Row className="top-rated-badge-container">
          {!isTopRatedBadgeEnabled && isTopRated && (
            <CustomBadge
              customFontWeight="bold"
              customFontSize={['fs10', 'fs10', 'fs10']}
              className="inline-badge-item"
              text={renderLabel(topRatedBadgeLabel, 'lbl_TCPBazaarVoiceRating')}
              link={link}
              type={TOP_RATED}
              sortByRatingLabel={sortByRatingLabel}
            />
          )}
          {!isBestSellerBackAbEnabled && isBestSeller && (
            <CustomBadge
              customFontWeight="bold"
              customFontSize={['fs10', 'fs10', 'fs10']}
              className="inline-badge-item"
              text={renderLabel(bestSellerBadgeLabel, 'lbl_best_seller')}
              type={BEST_SELLER}
            />
          )}
        </Row>
      );
    }
    if ((isTopRatedBadgeEnabledSLP || isBestSellerBadgeEnabledSLP) && parseBoolean(isSearchPage)) {
      return (
        <Row className="top-rated-badge-container">
          {isTopRatedBadgeEnabledSLP && isTopRated && (
            <CustomBadge
              customFontWeight="bold"
              customFontSize={['fs10', 'fs10', 'fs10']}
              className="inline-badge-item slp"
              text={topRatedBadgeLabel}
              type={TOP_RATED}
            />
          )}
          {isBestSellerBadgeEnabledSLP && isBestSeller && (
            <CustomBadge
              customFontWeight="bold"
              customFontSize={['fs10', 'fs10', 'fs10']}
              className="inline-badge-item slp"
              text={bestSellerBadgeLabel}
              type={BEST_SELLER}
            />
          )}
        </Row>
      );
    }
    return null;
  };

  getSendAnEmailComponent = () => {
    const { productInfo, className } = this.props;
    return productInfo.isGiftCard ? <SendAnEmailGiftCard className={className} /> : null;
  };

  getSimilarItemsToConsider = (items) => {
    const { isSimilarItemToConsiderEnabled, className } = this.props;
    return isSimilarItemToConsiderEnabled ? (
      <SimilarItemToConsider similarItems={items} className={className} />
    ) : null;
  };

  getProductPriceForGiftCard = () => {
    const { productInfo, currency, currencyAttributes, isLoading, isPlcc, isPerUnitPriceEnabled } =
      this.props;
    const { currentGiftCardValue } = this.state;
    const { TCPStyleQTY } = productInfo;
    const getGiftCardValue = currentGiftCardValue || productInfo.offerPrice;
    return productInfo.isGiftCard ? (
      <div className="product-price-mobile-view">
        {isLoading ? (
          <LoaderSkelton />
        ) : (
          <ProductPrice
            listPrice={parseInt(getGiftCardValue, 10)}
            offerPrice={parseInt(getGiftCardValue, 10)}
            currencyAttributes={currencyAttributes}
            currencySymbol={currency}
            isPlcc={isPlcc}
            isPerUnitPriceEnabled={isPerUnitPriceEnabled}
            TCPStyleQTY={TCPStyleQTY}
            isAfterPayDisplay
            isGiftCard
          />
        )}
      </div>
    ) : null;
  };

  // This is required for reommendations.
  getCatIdForRecommendation = () => {
    const { breadCrumbs } = this.props;
    if (breadCrumbs) {
      const category = breadCrumbs.map((crumb, index) => {
        const { displayName } = crumb;
        const separationChar = index !== breadCrumbs.length - 1 ? ':' : '';
        return displayName + separationChar;
      });
      return category.join('');
    }
    return '';
  };

  getCustomProductLength = () => {
    if (isClient() && getViewportInfo().isTablet) {
      return 4;
    }
    return 6;
  };

  renderPromoBanner = (promoBanners) => {
    const { asPathVal, isDynamicContentPDPEnabled, dynamicContentPromo } = this.props;
    return (
      <PromoPDPBanners
        promos={promoBanners}
        asPath={asPathVal}
        isDynamicContentPDPEnabled={isDynamicContentPDPEnabled && dynamicContentPromo}
        onLoad={this.handleDynamicComponentLoad}
      />
    );
  };

  renderPromo = (area, props) => {
    const { [`${area}Promos`]: promos } = props;
    return (
      promos &&
      promos.length > 0 && (
        <Row>
          <Col className={`promo-area-${area}`} colSize={{ small: 6, medium: 8, large: 12 }}>
            {this.renderPromoBanner(promos)}
          </Col>
        </Row>
      )
    );
  };

  getItemColor = () => {
    const { productInfo, formValues } = this.props;
    const { colorFitsSizesMap } = productInfo;
    const getFormName = formValues ? formValues.color : this.formValues.color;
    return getMapSliceForColor(colorFitsSizesMap, getFormName);
  };

  shouldDisplayProductInfo = () => {
    const { isValidProduct, isLoading } = this.props;
    return isValidProduct || isLoading;
  };

  getKeepAlive = () => {
    const { isKeepAliveEnabled } = this.props;
    const { currentColorEntry } = this.state;
    return (
      isKeepAliveEnabled &&
      currentColorEntry &&
      currentColorEntry.miscInfo &&
      currentColorEntry.miscInfo.keepAlive
    );
  };

  getSkuId = (colorProduct) => {
    const { formValues } = this.props;
    const size = formValues && formValues.Size;
    let skuId = null;
    if (typeof size === 'string' && size) {
      skuId = getMapSliceForSizeSkuID(colorProduct, size);
    }
    return skuId;
  };

  familyOutfitCheck = (isFamilyOutfitEnabled, isABTestLoaded, alternateSizesImageNameAndPath) => {
    const { isFamilyOutfitRightViewEnabled } = this.props;
    return (
      isFamilyOutfitEnabled &&
      isABTestLoaded &&
      alternateSizesImageNameAndPath.length > 0 &&
      !(isFamilyOutfitRightViewEnabled && window && window?.innerWidth >= 1920)
    );
  };

  getImgWrapperClass = (isCompleteTheLookTestEnabled) => {
    const wrapperClassName = isCompleteTheLookTestEnabled ? ` complete-the-look-test` : '';
    return `product-image-wrapper${wrapperClassName} sticky-mobile-image-wrapper`;
  };

  getBazaarVoiceScript = () => {
    if (this.loadBVScript) {
      this.setState({ showBazaarVoice: true });
      return <Script async={false} src={createBVUrl()} defer={true} />;
    }
    return null;
  };

  justFewLeftSection = (colorProduct) => {
    if (colorProduct?.fewSizesLeft) {
      const display = 'none';
      return (
        <div id="justAFewLeft1" style={{ display }}>
          <p>JustAFewLeft1</p>
        </div>
      );
    }
    return <></>;
  };

  getTopRatedPLPorSLP = ({
    isTopRatedBadgeEnabled,
    isTopRated,
    isSearchPage,
    isFromPLPPage,
    isTopRatedBadgeEnabledSLP,
  }) => {
    const { lbl_TCPBazaarVoiceRating: topRatedBadgeLabel } = this.pdpLabel;
    return (!isTopRatedBadgeEnabled &&
      isTopRated &&
      !parseBoolean(isSearchPage) &&
      isFromPLPPage) ||
      (isTopRatedBadgeEnabledSLP && isTopRated && parseBoolean(isSearchPage))
      ? renderLabel(topRatedBadgeLabel, 'lbl_TCPBazaarVoiceRating')
      : '';
  };

  getBestSellerPLPorSLP = ({
    isBestSellerBackAbEnabled,
    isBestSeller,
    isSearchPage,
    isFromPLPPage,
    isBestSellerBadgeEnabledSLP,
  }) => {
    const { lbl_best_seller: bestSellerBadgeLabel } = this.pdpLabel;
    return (!isBestSellerBackAbEnabled &&
      isBestSeller &&
      !parseBoolean(isSearchPage) &&
      isFromPLPPage) ||
      (isBestSellerBadgeEnabledSLP && isBestSeller && parseBoolean(isSearchPage))
      ? renderLabel(bestSellerBadgeLabel, 'lbl_best_seller')
      : '';
  };

  getMostFavoritedBadgePLPorSLP = ({ isMostFavoritedBadgeEnabled, isMostFavoritedBadge }) => {
    const { lbl_favoritedcount: mostFavorited } = this.pdpLabel;
    return !isMostFavoritedBadgeEnabled && isMostFavoritedBadge
      ? renderLabel(mostFavorited, 'lbl_favoritedcount')
      : '';
  };

  getInfluencerPickLabel = ({ isInfluencerPicksEnabled, currentColorEntry }) => {
    return (isInfluencerPicksEnabled && currentColorEntry?.influencerPicks?.[0]) || '';
  };

  getZoneOneBadges = ({
    isTopRatedBadgeEnabled,
    isTopRated,
    isSearchPage,
    isFromPLPPage,
    isTopRatedBadgeEnabledSLP,
    isBestSellerBackAbEnabled,
    isBestSellerBadgeEnabledSLP,
    isBestSeller,
    isMostFavoritedBadgeEnabled,
    isMostFavoritedBadge,
    isInfluencerPicksEnabled,
    currentColorEntry,
  }) => {
    const isTopRatedPLPorSLP = this.getTopRatedPLPorSLP({
      isTopRatedBadgeEnabled,
      isTopRated,
      isSearchPage,
      isFromPLPPage,
      isTopRatedBadgeEnabledSLP,
    });
    const isBestSellerPLPorSLP = this.getBestSellerPLPorSLP({
      isBestSellerBackAbEnabled,
      isBestSeller,
      isSearchPage,
      isFromPLPPage,
      isBestSellerBadgeEnabledSLP,
    });
    const isMostFavoritedBadgePLPorSLP = this.getMostFavoritedBadgePLPorSLP({
      isMostFavoritedBadgeEnabled,
      isMostFavoritedBadge,
    });
    const influencerPickLabel = this.getInfluencerPickLabel({
      isInfluencerPicksEnabled,
      currentColorEntry,
    });

    return getZoneOneBadgesArray({
      zoneOneBadges: currentColorEntry?.miscInfo?.zoneOneBadges,
      topRatedBadge: isTopRatedPLPorSLP,
      bestSellerBadge: isBestSellerPLPorSLP,
      mostFavoritedBadge: isMostFavoritedBadgePLPorSLP,
      influencerPickToDisplay: influencerPickLabel,
    });
  };

  updateSimilarProducts = (productid) => {
    const { APIConfig, productDetails, fetchSimilarProductsActn, isAISimilarStyleEnabled } =
      this.props;

    const { currentProduct } = productDetails;
    const { primaryBrand, allProductId, genderAgeGroup } = currentProduct;
    this.currentSelectedProductId = productid;
    this.currentSelectedProductImage = allProductId?.find(
      (item) => item.productid === this.currentSelectedProductId
    )?.productimage;
    if (isAISimilarStyleEnabled) {
      fetchSimilarProductsActn({
        productId: productid,
        brand: primaryBrand,
        APIConfig,
        gender: genderAgeGroup,
      });
    }
  };

  /* eslint-disable-next-line complexity, sonarjs/cognitive-complexity */
  render() {
    const {
      className,
      productDetails,
      longDescription,
      shortDescription,
      itemPartNumber,
      productInfo,
      handleAddToBag,
      addToBagError,
      alternateSizes,
      alternateStyles,
      isKeepAliveEnabled,
      currency,
      currencyAttributes,
      onAddItemToFavorites,
      isLoggedIn,
      topPromos,
      middlePromos,
      dynamicContentPromo,
      bottomPromos,
      belowrecsPromos,
      sizeChartDetails,
      isLoading,
      isOnModelAbTestPdp,
      isAbPdpPlaEnabled,
      completeLookSlotTile,
      isValidProduct,
      isShowPriceRangeKillSwitch,
      showPriceRangeForABTest,
      wishList,
      imgConfigVal,
      resetCountUpdate,
      socialProofMessage,
      countUpdated,
      addBtnMsg,
      multipackProduct,
      multiPackCount,
      multiPackThreshold,
      partIdInfo,
      getAllNewMultiPack,
      isRecommendationAvailable,
      isPerUnitPriceEnabled,
      getDetails,
      selectedMultipack,
      checkForOOSForVariant,
      isBrierleyPromoEnabled,
      isOosPdpEnabled,
      isPdpNewRecommendationEnabled,
      isPdp1andPdp2Enabled,
      largeImageNameOnHover,
      hasABTestForPDPColorOrImageSwatchHover,
      initialMultipackMapping,
      singlePageLoad,
      setInitialTCPStyleQty,
      resetProductDetailsDynamicData,
      onSetLastDeletedItemIdAction,
      formValues,
      deleteFavItemInProgressFlag,
      addToBagErrorId,
      disableMultiPackTab,
      getDisableSelectedTab,
      istMultiColorNameEnabled,
      isDynamicBadgeEnabled,
      isDynamicBadgeEnabledAbtest,
      fromPLPPage,
      availableTCPmapNewStyleId,
      isPDPSmoothScrollEnabled,
      isHiddenPDPAltImageEnabled,
      isFamilyOutfitEnabled,
      isABTestLoaded,
      isNewPDPEnabled,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      hidePriceDisplay,
      asPathVal,
      isShowBrandNameEnabled,
      openModal,
      alternateBrand,
      accessoriesData,
      isVerticalCTLEnabled,
      productInfo: { generalProductId },
      previousSearchPage,
      accessories,
      secondarySelectedAccessoryList,
      trackWishListClick,
      setProductDataForReviewActn,
      isRedesignedPdpDesktopView,
      isFromPLPPage,
      isTopRatedBadgeEnabled,
      isBestSellerBackAbEnabled,
      updateShowRecentlyViewedVertically,
      showRecentlyViewedVerticalView,
      isVerticalRecommendationsEnabled,
      isRecommendationSidebar,
      getRecommendationProduct,
      getSimilarItemToConsider,
      showVerticleScrollContainer,
      clearAddToBagError,
      isTakeDownRedirectionEnabled,
      isPlpPdpAnchoringEnabled,
      isAddBgdToTransparentImgEnabled,
      isSyteEnabled,
      userId,
      trackClick,
      trackClickWithoutDelay,
      syteRecommendations,
      isSyteScriptLoaded,
      breadCrumbs,
      currentCategoryIdPLP,
      isSimilarItemToConsiderEnabled,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBadgeEnabledSLP,
      isESGBadgePDPBackABEnabled,
      toastModalState,
      showToastModalAction,
      outfitV3WidgetEnabled,
      outfitV3WidgetMnMABTest,
      disableAlsoAvailablePills,
      IsImageIndicatorUpdateEnabled,
      isPixleeWidget,
      isDynamicContentPDPEnabled,
      showDynamicContentLoader,
      aspectRatioObjNew,
      dynamicPromoPerfSwitch,
      isPinchZoomPDPImageEnabled,
      isPlccPriceOnPDP,
      isPLCCBannerPriceEnabled,
      isPDPRedesignEnabled,
      isInfluencerPicksEnabled,
      isInternationalShipping,
      additionalPromoModuleXContent,
      additionalPromoModuleXContentId,
      isBopisFilterOn,
      activeTabIndex,
      setPdpTabSectionIndex,
      productInfoQV,
      plccOfferPercentage,
      isRcommAboveProdDesc,
      imageConfigWithoutDPR,
      storeSpecialDiscount,
      isStoreSpecialsPriceOn,
      fromBagPage,
      dynamicBadgeOverlayQty,
      defaultStoreId,
      storeSpecialList,
      storeSpecialV2Enabled,
      fetchShippingAndReturnsModule,
      shippingAndReturnsModuleXContent,
      isShippedAndReturnsTabEnabled,
      isFromHeroProductTile,
      similarProducts,
      onQuickViewOpenClick,
      isAISimilarStyleEnabled,
      saveProductDataForPdp,
      isSimilarProductsModalOpen,
      ...otherProps
    } = this.props;
    let { isCompleteTheLookTestEnabled } = this.props;
    const {
      isGiftCard,
      TCPStyleQTY,
      TCPStyleType,
      TCPStyleColor,
      colorFitsSizesMap,
      imagesByColor,
      primaryBrand,
      categoryPathMap,
      allProductId,
      primaryCategory,
      isMostFavoritedBadgeEnabled,
      promotionalMessage,
      promotionalPLCCMessage,
    } = productInfo;
    const colorNameAvailable = formValues ? formValues.color : this.formValues?.color;
    const {
      showBazaarVoice,
      starRatingClicked,
      syteRecos,
      isDynamicComponentReady,
      isPickupSelectedAtProductDetail,
      hasMounted,
    } = this.state;
    const {
      ratingsProductId,
      isPlcc,
      router: {
        asPath,
        query: { isSearchPage, fromStoreDetail },
      },
      isNewPJPPDPRedesignEnabled,
      activeTabSection,
      setPdpTabSectionName,
      isQvPdpInfluencerHandleAbTest,
      activePromotions,
    } = otherProps;
    const isFromSLPPage = parseBoolean(isSearchPage);
    const { currentProduct, currentProductDynamicData } = productDetails;
    const { productId } = currentProduct;
    let imagesToDisplay = [];
    let imageSwatchesToDisplay = [];
    const isProductDataAvailable = Object.keys(productInfo).length > 0;
    const { currentColorEntry, renderReceiveProps } = this.state;
    const { colorDisplayId, colorProductId } = currentColorEntry || {};
    const initialSelectedColor = this.formValues?.color;
    const getFormName =
      formValues && !isEmpty(formValues) ? formValues.color : initialSelectedColor;
    const updatedColorEntry = getMapSliceForColor(colorFitsSizesMap, getFormName);
    let newColorList =
      istMultiColorNameEnabled && TCPStyleColor && TCPStyleColor.length
        ? getMapColorList(TCPStyleColor, updatedColorEntry)
        : getFormName && [getFormName];
    // colorList should never be empty, even if color is not coming
    // from TCPStyleColor then we default to the formValue.
    if (!newColorList && TCPStyleColor && TCPStyleColor.length) {
      newColorList = getFormName && [getFormName];
    }
    if (!isEqual(newColorList, this.newColorListHolder)) {
      this.newColorListHolder = newColorList;
    }
    const variantNumber = this.getVariantNumber(updatedColorEntry, formValues);
    const keepAlive = this.getKeepAlive();
    if (isProductDataAvailable) {
      imagesToDisplay = getImagesToDisplay({
        imagesByColor,
        curentColorEntry:
          !updatedColorEntry || generalProductId?.includes(`$brand=${alternateBrand}`)
            ? currentColorEntry
            : updatedColorEntry,
        isAbTestActive: isOnModelAbTestPdp,
        isFullSet: true,
      });
      imageSwatchesToDisplay = getPrimaryImages({
        imagesByColor,
        curentColorEntry: !updatedColorEntry ? currentColorEntry : updatedColorEntry,
        isAbTestActive: isOnModelAbTestPdp,
        isFullSet: true,
      });
      if (!isEqual(imageSwatchesToDisplay, this.imageSwatchesToDisplayHolder)) {
        this.imageSwatchesToDisplayHolder = imageSwatchesToDisplay;
      }
    }

    let dpr = `dpr_1.5`;
    const sizeChartImage =
      currentColorEntry &&
      currentColorEntry?.isLicensed &&
      imagesToDisplay?.find((img) => img.listingSizeImageUrl.includes('-sizechart'));
    const dprValue = isClient() && window && Math.floor(window.devicePixelRatio);
    if (dprValue === 2) {
      dpr = `dpr_1.5`;
    } else {
      dpr = dprValue ? `dpr_${dprValue}` : `dpr_1.5`;
    }
    const sizeChartImageURL = sizeChartImage
      ? `${getAssetHostURL()}/t_pdp_img_d,f_auto,q_auto,${dpr}/v1/ecom/assets/products/${getBrandName(
          primaryBrand,
          alternateBrand
        )}/${sizeChartImage.listingSizeImageUrl}`
      : '';
    const imgForSeo = `${getAssetHostURL()}/t_plp_img_m,f_auto,q_auto,dpr_1/v1/ecom/assets/products/${getBrandName(
      primaryBrand,
      alternateBrand
    )}/${imagesToDisplay?.[0]?.regularSizeImageUrl}`;

    if (!isUsOnly()) {
      isCompleteTheLookTestEnabled = false;
    }

    const sizeChartLinkVisibility = !isGiftCard ? SIZE_CHART_LINK_POSITIONS.AFTER_SIZE : null;
    const carouselOptions = ProductDetailsUtils.PDPCarouselOptions.CAROUSEL_OPTIONS;
    const productOfferPrice = currentColorEntry?.offerPrice || currentColorEntry?.listPrice;

    const categoryId = this.getCatIdForRecommendation();
    const customProductsLength = this.getCustomProductLength();
    const recommendationAttributes = {
      variations: 'moduleO',
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.PDP,
      categoryName: categoryId,
      partNumber: productId,
      showLoyaltyPromotionMessage: false,
      headerAlignment: 'left',
      outOfStock: checkForOOSForVariant,
      recommendationCarouselRedesign: true,
      primaryCategory,
    };

    if (isValidObj(currentProductDynamicData)) {
      this.pdpProductDetails.currentProduct = currentProductDynamicData;
    } else if (isValidObj(currentProduct)) {
      this.pdpProductDetails.currentProduct = currentProduct;
    }

    const isInWishList = checkInWishlistUtil(
      wishList,
      colorDisplayId || this.pdpProductDetails.currentProduct.generalProductId
    );

    const itemColorObj = this.getItemColor();
    const showPriceRange = isShowPriceRangeKillSwitch && showPriceRangeForABTest;
    const altSizesImageNameAndPath = Object.entries(alternateStyles || {});
    const alternateSizesImageNameAndPath = altSizesImageNameAndPath.filter((subArray) => {
      return !subArray.some((item) => item.includes(productId.replace('_', '-')));
    });
    const productIdForSwatch = itemColorObj && itemColorObj.colorDisplayId;
    const colorProduct =
      getMapSliceForColorProductId(productInfo.colorFitsSizesMap, colorProductId) || {};
    const prodSku = this.getSkuId(colorProduct);
    const { TCPPromotionID, minStorePrice, maxStorePrice, storeId } = colorProduct || {};
    const storeSpecialPriceRange = { minStorePrice, maxStorePrice, storeId };
    const isMobile = isClient() ? getViewportInfo().isMobile : null;
    const { currentGiftCardValue, minOfferPrice, maxOfferPrice, minListPrice, maxListPrice } =
      this.state;
    const getGiftCardValue = currentGiftCardValue || productInfo.offerPrice;
    const isAccessoryPresentMandatory = getIsAccessoryPresentMandatory(
      minOfferPrice,
      maxOfferPrice,
      minListPrice,
      maxListPrice
    );
    const priceInfoAccessoryPresent = this.getPriceInfoAccessoryPresent();
    const recentlyViewedLength = getRecommendationProduct?.filter(
      (val) => val?.isRecentViewed === true
    )?.length;
    const hideRecentlyViewdClass =
      isVerticalRecommendationsEnabled && showVerticleScrollContainer && recentlyViewedLength > 0
        ? 'pdp-vertical-recomendation'
        : '';
    const hideYouMayLikeClass =
      isVerticalRecommendationsEnabled && showVerticleScrollContainer && recentlyViewedLength === 0
        ? 'pdp-vertical-recomendation'
        : '';

    const RenderSyteRecommendations = () => {
      const sku = prodSku ?? colorProductId;
      const SyteConfig = {
        image: `${getAssetHostURL()}/v1/ecom/assets/products/${getBrandName(
          primaryBrand,
          alternateBrand
        )}/${imagesToDisplay?.[0]?.regularSizeImageUrl}`,
        sku,
        placement: 'PDP',
        trackClick,
      };

      const carousels = syteRecommendations?.carousels?.sort((a, b) => a?.order - b?.order);

      const RenderCarousels = carousels?.map((carousel) => {
        const newSyteConfig = Object.assign({}, SyteConfig);
        const recommendationClasses = `syte-${syteRecommendations.position}`;
        newSyteConfig.id = carousel?.id;
        newSyteConfig.multiSkus = carousel?.multiSkus;
        if (carousel?.enabled) {
          return (
            <Row
              key={carousel?.order}
              className={recommendationClasses}
              fullBleed={{ small: true, medium: true, large: false }}
            >
              <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                <SyteRecommendations config={newSyteConfig} />
              </Col>
            </Row>
          );
        }

        return null;
      });

      return <>{RenderCarousels}</>;
    };

    const handleAddToBagClick = (id, fromPage) => {
      if (onQuickViewOpenClick) {
        const payload = { colorProductId: id };
        if (fromPage) {
          payload.fromPage = fromPage;
        }
        onQuickViewOpenClick(payload);
      }
    };

    const badge1 = currentColorEntry?.miscInfo?.badge1;
    const topRatedBadgeSLP = currentColorEntry?.miscInfo?.topRatedSLP;
    const bestSellerBadgeSLP = currentColorEntry?.miscInfo?.bestSellerSLP;

    const isTopRated = this.getIsTopRatedOrBestSellerBadge({
      badge1,
      currentCategoryIdPLP,
      badgeSLP: topRatedBadgeSLP,
      callback: getTopRatedBadge,
    });

    const link = breadCrumbs?.length > 1 && breadCrumbs[breadCrumbs?.length - 1];
    const isBestSeller = this.getIsTopRatedOrBestSellerBadge({
      badge1,
      currentCategoryIdPLP,
      badgeSLP: bestSellerBadgeSLP,
      callback: getBestSellerBadge,
    });

    const isMostFavoritedBadge = this.getIsTopRatedOrBestSellerBadge({
      badge1,
      currentCategoryIdPLP,
      badgeSLP: currentColorEntry?.miscInfo?.mostFavoritedSLP,
      callback: getMostFavoriteBadge,
    });

    const isTopRatedOrBestSellerPLPSwitch = !isTopRatedBadgeEnabled || !isBestSellerBackAbEnabled;

    const isTopRatedOrBestSellerSLPSwitch =
      isTopRatedBadgeEnabledSLP || isBestSellerBadgeEnabledSLP;

    const isTopRatedOrBestSellerBadge = isTopRated || isBestSeller;

    const shouldRenderTopRatedOrBestSellerBadge =
      (isTopRatedOrBestSellerPLPSwitch || isTopRatedOrBestSellerSLPSwitch) &&
      isTopRatedOrBestSellerBadge;

    const productBadges =
      isMobile &&
      getCurrentProductBadges({ backAB: isESGBadgePDPBackABEnabled, allProductId, colorDisplayId });

    const syteComponent = isClient() && RenderSyteRecommendations();
    if (!syteRecos) {
      this.setState({ syteRecos: syteComponent });
    }
    const isSyteReady = isSyteScriptLoaded || (isClient() && window?.SyteApp?.isReady);

    const zoneOneBadges = this.getZoneOneBadges({
      isTopRatedBadgeEnabled,
      isTopRated,
      isSearchPage,
      isFromPLPPage,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBackAbEnabled,
      isBestSeller,
      isMostFavoritedBadgeEnabled,
      isMostFavoritedBadge,
      isInfluencerPicksEnabled,
      currentColorEntry,
      isBestSellerBadgeEnabledSLP,
    });

    const loyaltyPromotionText = getPromotionalMessage(isPlcc, {
      promotionalMessage,
      promotionalPLCCMessage,
    });

    const promotionPrice = isServer() ? this.extractPromotionPrice() : this.state.promotionPrice;
    const { storeSpecials, offerPrice, TCPPromotionPrice } = currentColorEntry;
    const storeSpecialInCurrentStore = storeSpecialV2Enabled
      ? !!storeSpecialList?.[defaultStoreId]
      : true;
    const storeSpecialDiscountPromotionEnabled =
      storeSpecials && isStoreSpecialsPriceOn && storeSpecialInCurrentStore;
    const tmpPromotionalPrice =
      TCPPromotionID && activePromotions[TCPPromotionID] ? TCPPromotionPrice : '';
    let promoPriceForStoreSpecial = tmpPromotionalPrice;
    if (storeSpecialDiscountPromotionEnabled) {
      promoPriceForStoreSpecial = calculateFinalPrice(
        offerPrice,
        storeSpecialDiscount,
        tmpPromotionalPrice,
        storeSpecialPriceRange,
        defaultStoreId
      );
    }
    const totalProducts = similarProducts?.length || 0;
    const breakPointVal = hasMounted
      ? calculateBreakPointByWidth([window?.innerWidth])
      : calculateBreakPointByWidth([1440]);

    const { name, genderAgeGroup } = currentProduct;

    const getImageUrl = (prodId, prodImage) => {
      if (isEmpty(prodId)) return null;

      const basePart = prodId.split('_')[0];
      return `${basePart}/${prodImage}`;
    };

    const getBrandVal = (TCPPrimaryBrandUSStore, TCPPrimaryBrandCanadaStore) =>
      !isCanada() ? TCPPrimaryBrandUSStore : TCPPrimaryBrandCanadaStore;

    return (
      <BadgesProvider productId={colorProductId} isLoggedIn={isLoggedIn} isPDP>
        <div className={className}>
          <div id="stickyAtbPortal" className="header-sticky-atb-wrapper" />
          {this.shouldDisplayProductInfo() ? (
            <>
              <Row
                fullBleed={{ small: true, medium: true, large: false }}
                className="product-recommendation-list-container"
              >
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  <div className={`${className} product-recommendation-list`}>
                    {checkForOOSForVariant &&
                      isOosPdpEnabled &&
                      colorNameAvailable &&
                      !isLoading && (
                        <Recommendations
                          headerLabel={renderLabel(
                            this.pdpLabel.lbl_pdp_pla_abtest,
                            'lbl_pdp_pla_abtest'
                          )}
                          portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.OUT_OF_STOCK_PDP}
                          {...recommendationAttributes}
                          priceOnly
                          customProductsLength={customProductsLength}
                          inheritedStyles={recommendationStylesPdp}
                          carouselConfigProps={carouselOptions}
                          sequence="1"
                          accordionHeader
                          isPdpPlaProducts
                          outOfStock
                          pdpDataInformation={this.pdpDataInformation}
                          topRecommendationOOS
                          isRecommendationMarginEnabled={isNewPJPPDPRedesignEnabled}
                          isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                        />
                      )}
                    {isAbPdpPlaEnabled && colorNameAvailable && !isLoading && (
                      <Recommendations
                        headerLabel={renderLabel(
                          this.pdpLabel.lbl_pdp_pla_abtest,
                          'lbl_pdp_pla_abtest'
                        )}
                        portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.CHECKOUT_SIMILAR_STYLES}
                        {...recommendationAttributes}
                        priceOnly
                        customProductsLength={customProductsLength}
                        inheritedStyles={recommendationStylesPdp}
                        carouselConfigProps={carouselOptions}
                        sequence="1"
                        accordionHeader
                        isPdpPlaProducts
                        pdpDataInformation={this.pdpDataInformation}
                        isNewPDPEnabled={isNewPDPEnabled}
                        topRecommendationOOS
                        isRecommendationMarginEnabled={isNewPJPPDPRedesignEnabled}
                        isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                      />
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col
                  className="product-breadcrumb-wrapper"
                  colSize={{ small: 6, medium: 8, large: 12 }}
                >
                  {this.getBreadCrumb()}
                </Col>
              </Row>
              {this.renderPromo('top', this.props)}
              {shouldRenderTopRatedOrBestSellerBadge &&
                !isPDPRedesignEnabled &&
                this.getTopBadge({ isTopRated, isBestSeller, link })}
              <Row className="product-content-wrapper">
                {isPDPRedesignEnabled &&
                  !this.apiConfig?.isBotRequest &&
                  this.getProductSummary({
                    keepAlive,
                    handleMetaProps: false,
                    isInWishList,
                    zoneOneBadges,
                    promotionPrice,
                    additionalClassName: ' product-summary-mobile-view-new-design',
                    promoPriceForStoreSpecial,
                    isShowNonH1Title: false,
                  })}
                {<Col colSize={{ small: 6, medium: 8, large: 12 }} />}
                <Col
                  className={this.getImgWrapperClass(isCompleteTheLookTestEnabled)}
                  colSize={{ small: 6, medium: 4, large: 7 }}
                  ignoreNthRule={true}
                >
                  <ProductImagesWrapper
                    productName={productInfo.name}
                    isGiftCard={isGiftCard}
                    isThumbnailListVisible
                    images={imagesToDisplay}
                    isZoomEnabled
                    currentProduct={currentProduct}
                    onChangeColor={this.onChangeColor}
                    currentColorEntry={currentColorEntry}
                    initialValues={this.formValues}
                    keepAlive={keepAlive}
                    ratingsProductId={ratingsProductId}
                    completeLookSlotTile={completeLookSlotTile}
                    itemPartNumber={itemPartNumber}
                    imgConfigVal={imgConfigVal}
                    checkForOOSForVariant={checkForOOSForVariant}
                    isCompleteTheLookTestEnabled={isCompleteTheLookTestEnabled}
                    imagesByColor={productInfo.imagesByColor}
                    largeImageNameOnHover={largeImageNameOnHover}
                    hasABTestForPDPColorOrImageSwatchHover={hasABTestForPDPColorOrImageSwatchHover}
                    pdpDataInformation={this.pdpDataInformation}
                    deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
                    TCPStyleQTY={TCPStyleQTY}
                    TCPStyleType={TCPStyleType}
                    isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                    isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
                    fromPLPPage={fromPLPPage}
                    wishList={wishList}
                    isPDPSmoothScrollEnabled={isPDPSmoothScrollEnabled}
                    isNewPDPEnabled={isNewPDPEnabled}
                    onAddItemToFavorites={onAddItemToFavorites}
                    productInfo={productInfo}
                    selectedColorProductId={colorProductId}
                    productMiscInfo={colorProduct}
                    pageName="PDP"
                    skuId={prodSku}
                    onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                    formName={PRODUCT_ADD_TO_BAG}
                    primaryBrand={primaryBrand}
                    isLoggedIn={isLoggedIn}
                    isInWishList={isInWishList}
                    alternateBrand={alternateBrand}
                    socialProofMessage={socialProofMessage}
                    isHiddenPDPAltImageEnabled={isHiddenPDPAltImageEnabled}
                    isTopRatedOrBestSeller={isTopRated || isBestSeller}
                    isPDP
                    trackWishListClick={trackWishListClick}
                    isRedesignedPdpDesktopView={isRedesignedPdpDesktopView}
                    isSyteEnabled={isSyteEnabled}
                    trackAnalyticsClick={trackClick}
                    isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                    influencerTags={currentColorEntry?.influencerTags}
                    isQvPdpInfluencerHandleAbTest={isQvPdpInfluencerHandleAbTest}
                    outfitV3WidgetEnabled={outfitV3WidgetEnabled}
                    IsImageIndicatorUpdateEnabled={IsImageIndicatorUpdateEnabled}
                    isPinchZoomPDPImageEnabled={isPinchZoomPDPImageEnabled}
                    isPDPRedesignEnabled={isPDPRedesignEnabled}
                    isBopisFilterOn={isBopisFilterOn}
                    imageConfigWithoutDPR={imageConfigWithoutDPR}
                    fromBagPage={fromBagPage}
                    dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
                    isFromHeroProductTile={isFromHeroProductTile}
                  />
                </Col>
                <Col
                  id="productDetailsSection"
                  className="product-detail-section sticky-product-detail"
                  colSize={{ small: 6, medium: 4, large: 5 }}
                >
                  <div className="sticky-product-detail-section">
                    {!isPDPRedesignEnabled && isNewPDPEnabled && (
                      <div
                        className={`hide-on-mobile ${
                          isGiftCard ? 'product-summary-desktop-view' : ''
                        }`}
                      >
                        {this.getProductSummary({
                          keepAlive,
                          handleMetaProps: true,
                          isInWishList,
                          promotionPrice,
                          promoPriceForStoreSpecial,
                        })}
                      </div>
                    )}
                    {isPDPRedesignEnabled &&
                      this.getProductSummary({
                        keepAlive,
                        handleMetaProps: false,
                        isInWishList,
                        zoneOneBadges,
                        promotionPrice,
                        additionalClassName: ' product-summary-non-mobile-view-new-design',
                        promoPriceForStoreSpecial,
                        isShowNonH1Title: true,
                      })}
                    {isPDPRedesignEnabled && (
                      <div>
                        {this.getProductSummary({
                          keepAlive,
                          handleMetaProps: true,
                          isInWishList,
                          shouldRenderPriceOnly: true,
                          zoneOneBadges,
                          promotionPrice,
                          promoPriceForStoreSpecial,
                        })}
                      </div>
                    )}
                    {!(isNewPDPEnabled && isMobile) && this.getProductPriceForGiftCard()}
                    {middlePromos && middlePromos.length > 0 && (
                      <div className="promo-area-middle">
                        {this.renderPromoBanner(middlePromos)}
                      </div>
                    )}
                    {currentProduct && (
                      <ProductAddToBagContainer
                        handleFormSubmit={handleAddToBag}
                        errorOnHandleSubmit={addToBagError}
                        currentProduct={this.pdpProductDetails.currentProduct}
                        onChangeColor={this.onChangeColor}
                        customSubmitButtonStyle={customSubmitButtonStyle}
                        onChangeSize={this.onChangeSize}
                        updateQuantityChange={this.updateQuantityChange}
                        selectedColorProductId={colorProductId}
                        renderReceiveProps={renderReceiveProps}
                        initialFormValues={this.formValues}
                        isPDP
                        alternateSizes={alternateSizes}
                        sizeChartLinkVisibility={sizeChartLinkVisibility}
                        isKeepAliveEnabled={isKeepAliveEnabled}
                        sizeChartDetails={sizeChartDetails}
                        isLoading={isLoading}
                        addBtnMsg={addBtnMsg}
                        multipackProduct={multipackProduct}
                        multiPackCount={multiPackCount}
                        multiPackThreshold={multiPackThreshold}
                        partIdInfo={partIdInfo}
                        getAllNewMultiPack={getAllNewMultiPack}
                        isRecommendationAvailable={isRecommendationAvailable}
                        getDetails={getDetails}
                        fromPDP
                        selectedMultipack={selectedMultipack}
                        TCPStyleQTY={TCPStyleQTY}
                        checkForOOSForVariant={checkForOOSForVariant}
                        imageSwatchesToDisplay={this.imageSwatchesToDisplayHolder}
                        initialMultipackMapping={initialMultipackMapping}
                        singlePageLoad={singlePageLoad}
                        setInitialTCPStyleQty={setInitialTCPStyleQty}
                        resetProductDetailsDynamicData={resetProductDetailsDynamicData}
                        addToBagErrorId={addToBagErrorId}
                        disableMultiPackTab={disableMultiPackTab}
                        getDisableSelectedTab={getDisableSelectedTab}
                        newColorList={this.newColorListHolder}
                        formValues={formValues}
                        isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                        isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
                        availableTCPmapNewStyleId={availableTCPmapNewStyleId}
                        wishList={wishList}
                        socialProofMessage={socialProofMessage}
                        isFamilyOutfitEnabled={isFamilyOutfitEnabled}
                        isNewPDPEnabled={isNewPDPEnabled}
                        isNewQVEnabled={isNewPDPEnabled}
                        primaryBrand={primaryBrand}
                        keepAlive={keepAlive}
                        isGiftCard={isGiftCard}
                        pdpProductDetails={this.pdpProductDetails}
                        currencySymbol={currency}
                        currencyAttributes={currencyAttributes}
                        onAddItemToFavorites={onAddItemToFavorites}
                        isLoggedIn={isLoggedIn}
                        isHasPlcc={isPlcc}
                        isInWishList={isInWishList}
                        resetCountUpdate={resetCountUpdate}
                        countUpdated={countUpdated}
                        isPerUnitPriceEnabled={isPerUnitPriceEnabled}
                        isBrierleyPromoEnabled={isBrierleyPromoEnabled}
                        onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                        deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
                        isLowTier={this.isLowTier}
                        isOutfitPage={false}
                        colorDisplayId={colorDisplayId}
                        productDetailsPDP={productDetails}
                        productInfo={productInfo}
                        AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
                        removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
                        hidePriceDisplay={hidePriceDisplay}
                        getGiftCardValue={getGiftCardValue}
                        isShowBrandNameEnabled={isShowBrandNameEnabled}
                        openModal={openModal}
                        alternateBrandFromUrl={alternateBrand}
                        alternateBrand={alternateBrand}
                        handleRatingClick={this.handleRatingClick}
                        accessoriesData={accessoriesData}
                        previousSearchPage={previousSearchPage}
                        isAccessoryPresentMandatory={isAccessoryPresentMandatory}
                        priceInfoAccessoryPresent={priceInfoAccessoryPresent}
                        accessories={accessories}
                        secondarySelectedAccessoryList={secondarySelectedAccessoryList}
                        filteredFitFromPDP={this.filteredFitFromPDP}
                        isCustomFormPartWeb={isFromPLPPage || isFromSLPPage}
                        isFromPLPPage={isFromPLPPage}
                        isFromSLPPage={isFromSLPPage}
                        isPlpPdpAnchoringEnabled={isPlpPdpAnchoringEnabled}
                        trackClickWithoutDelay={trackClickWithoutDelay}
                        isPDPRedesignEnabled={isPDPRedesignEnabled}
                        productInfoQV={productInfoQV}
                        updatePickupSelectedAtProductDetail={
                          this.updatePickupSelectedAtProductDetail
                        }
                        setMethod={this.setMethod}
                        storeSpecials={storeSpecials}
                        fromStoreDetail={fromStoreDetail}
                        updateSimilarProducts={this.updateSimilarProducts}
                      />
                    )}
                    {storeSpecialDiscountPromotionEnabled && (
                      <StoreSpecialPromotion
                        isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
                        handlePickupSelection={this.handlePickupSelection}
                        priceAfterDiscount={promoPriceForStoreSpecial}
                        offerPrice={offerPrice}
                        TCPPromotionPrice={tmpPromotionalPrice}
                      />
                    )}

                    {isAISimilarStyleEnabled && isPDPRedesignEnabled && hasMounted && (
                      <div className="similar-items-wrapper" key={`similar-items-${productId}`}>
                        {similarProducts?.length > 0 ? (
                          <>
                            <div className="similar-items-header-wrapper">
                              <div className="similar-styles-header">
                                <h3>
                                  {`${renderLabel(
                                    getDynamicLabelValues(
                                      'dynamic.browse_d.lbl_modalOffer_detail_heading_text'
                                    ),
                                    'lbl_modalOffer_detail_heading_text'
                                  )}`}
                                </h3>
                                <Anchor
                                  onClick={this.handleSimilarProductsModalToggle}
                                  className="view-all-link"
                                >
                                  {renderLabel(
                                    this.globalLabels?.placeRewards?.lbl_my_rewards_viewAll,
                                    'lbl_my_rewards_viewAll'
                                  )}
                                </Anchor>
                              </div>
                              <p>
                                {`${renderLabel(
                                  getDynamicLabelValues(
                                    'dynamic.browse_d.lbl_similar_product_description'
                                  ),
                                  'lbl_similar_product_description'
                                )}`}
                              </p>
                            </div>

                            <div className="my-carousel-wrapper" ref={this.productTileRef}>
                              <Carousel
                                key={`similar-carousel-${productId}`}
                                isArrowVisible={
                                  totalProducts > ARROW_VISIBLE_SIMILAR_PRODUCTS[breakPointVal]
                                }
                                tileRef={this.productTileRef}
                                ref={this.productTileRef}
                                defaultTileWidth={265}
                                slidesToScroll={SLIDES_TO_SCROLL_SIMILAR_PRODUCTS[breakPointVal]}
                                isCategoryTab={false}
                                customCls="similarProductCarousel"
                              >
                                {similarProducts.slice(0, 8).map((product, index) => {
                                  const brand = getBrandVal(
                                    product.TCPPrimaryBrandUSStore,
                                    product.TCPPrimaryBrandCanadaStore
                                  );
                                  return (
                                    <div
                                      key={`${product.uniqueId || index}-${productId}`}
                                      className="carousel-item"
                                      role="button"
                                      tabIndex="0"
                                      aria-label={`View details for ${
                                        product.product_name || 'product'
                                      }`}
                                      onClick={() => handleAddToBagClick(product.uniqueId)}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                          e.preventDefault();
                                          handleAddToBagClick(product.uniqueId);
                                        }
                                      }}
                                    >
                                      <DamImage
                                        imgData={{
                                          alt:
                                            product.product_name || `Product ${product.uniqueId}`,
                                          url:
                                            getImageUrl(product.productid, product.productimage) ||
                                            '',
                                        }}
                                        className="product-image"
                                        isProductImage
                                        lazyLoadImage
                                        primaryBrand={brand}
                                      />
                                    </div>
                                  );
                                })}
                              </Carousel>
                            </div>
                            {isSimilarProductsModalOpen && (
                              <SimilarProductsModal
                                isOpen={isSimilarProductsModalOpen}
                                onRequestClose={this.handleSimilarProductsModalToggle}
                                similarProducts={similarProducts}
                                onAfterClose={this.unlockBodyScroll}
                                className="similar-innerContent"
                                onQuickViewOpenClick={onQuickViewOpenClick}
                                handleAddToBagClick={handleAddToBagClick}
                                TCPColor={this.formValues?.color}
                                name={name}
                                departmentName={genderAgeGroup}
                                productId={this.currentSelectedProductId}
                                pdpImage={this.currentSelectedProductImage}
                                getImageUrl={getImageUrl}
                                getBrandVal={getBrandVal}
                                saveProductDataForPdp={saveProductDataForPdp}
                              />
                            )}
                          </>
                        ) : null}
                      </div>
                    )}

                    {isPDPRedesignEnabled && (
                      <div className="promo-section-parent">
                        {!isCanada() && !isPlcc && (
                          <PlccWrapperStatic
                            openModal={openModal}
                            currencyAttributes={currencyAttributes}
                            isPlccPriceOnPDP={isPlccPriceOnPDP}
                            isPDPRedesignEnabled={isPDPRedesignEnabled}
                            productOfferPrice={productOfferPrice}
                            isPLCCBannerPriceEnabled={isPLCCBannerPriceEnabled}
                            plccOfferPercentage={plccOfferPercentage}
                          />
                        )}
                        {additionalPromoModuleXContentId &&
                        !additionalPromoModuleXContent?.richText ? (
                          <div className="product-property-section">
                            <LoaderSkelton height="49px" />
                          </div>
                        ) : null}
                        {additionalPromoModuleXContentId &&
                        additionalPromoModuleXContent?.richText ? (
                          <ModuleX
                            richTextList={[{ text: additionalPromoModuleXContent.richText }]}
                          />
                        ) : null}
                        {isBrierleyPromoEnabled && !(isCanada() && isGymboree()) && (
                          <PointsAndRewards />
                        )}
                        {!isCanada() && !isInternationalShipping && loyaltyPromotionText && (
                          <RedesignPDPPromotionalMessage
                            text={loyaltyPromotionText}
                            isPlcc={isPlcc}
                          />
                        )}
                        {!isLoading ? (
                          <LoyaltyBanner
                            pageCategory="isProductDetailView"
                            ratingsProductId={ratingsProductId}
                            isCompleteTheLookTestEnabled={isCompleteTheLookTestEnabled}
                            openModalLearnMore={openModal}
                          />
                        ) : (
                          <div className="product-property-section">
                            <LoaderSkelton height="49px" />
                          </div>
                        )}
                      </div>
                    )}
                    {
                      <div>
                        <script
                          type="application/ld+json"
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: JSON.stringify(
                              this.getSeoData(
                                productDetails,
                                currentColorEntry,
                                currency,
                                checkForOOSForVariant,
                                imgForSeo,
                                asPath,
                                promotionPrice
                              )
                            ),
                          }}
                        />
                      </div>
                    }

                    {!isNewPJPPDPRedesignEnabled && (
                      <div className="product-detail-section key-feature-section">
                        {!isGiftCard && isNewPDPEnabled && !isMobile && (
                          <ProductDescription
                            productId={itemPartNumber}
                            productInfo={productInfo}
                            isShowMore={false}
                            shortDescription={shortDescription}
                            longDescription={longDescription}
                            color={itemColorObj && itemColorObj.color && itemColorObj.color.name}
                            isPDP
                            TCPStyleColor={TCPStyleColor}
                            wishList={wishList}
                            isNewPDPEnabled
                            primaryBrand={primaryBrand}
                            variantNumber={variantNumber}
                          />
                        )}
                      </div>
                    )}
                    {this.getSimilarItemsToConsider(getSimilarItemToConsider)}
                    {this.familyOutfitCheck(
                      isFamilyOutfitEnabled,
                      isABTestLoaded,
                      alternateSizesImageNameAndPath
                    ) ? (
                      <div
                        className={`${
                          this.familyOutfitCheck(
                            isFamilyOutfitEnabled,
                            isABTestLoaded,
                            alternateSizesImageNameAndPath
                          )
                            ? 'border-background-new-design'
                            : ''
                        }`}
                      >
                        <div
                          className={`${
                            this.familyOutfitCheck(
                              isFamilyOutfitEnabled,
                              isABTestLoaded,
                              alternateSizesImageNameAndPath
                            )
                              ? 'also-available-wrapper-new-design'
                              : ''
                          }`}
                        >
                          {disableAlsoAvailablePills &&
                          isFamilyOutfitEnabled &&
                          isABTestLoaded &&
                          alternateSizesImageNameAndPath.length > 0 ? (
                            <div className="also-available">
                              {renderLabel(
                                this.pdpLabel.lbl_plp_also_available_in,
                                'lbl_plp_also_available_in'
                              )}
                            </div>
                          ) : null}
                          {disableAlsoAvailablePills &&
                          isFamilyOutfitEnabled &&
                          isABTestLoaded &&
                          alternateSizesImageNameAndPath.length > 0 ? (
                            <FamilyOutfit
                              alternateSizesImageNameAndPath={alternateSizesImageNameAndPath}
                              alternateBrand={alternateBrand}
                              getDetails={getDetails}
                              clearAddToBagError={clearAddToBagError}
                              resetProductDetailsDynamicData={resetProductDetailsDynamicData}
                              isTakeDownRedirectionEnabled={isTakeDownRedirectionEnabled}
                              isPlpPdpAnchoringEnabled={isPlpPdpAnchoringEnabled}
                              isNewPDPEnabled
                              trackClickWithoutDelay={trackClickWithoutDelay}
                              isAddBgdToTransparentImgEnabled={isAddBgdToTransparentImgEnabled}
                              primaryBrand={primaryBrand}
                            />
                          ) : null}
                        </div>
                      </div>
                    ) : null}

                    {
                      // eslint-disable-next-line no-nested-ternary
                      isPDPRedesignEnabled ? null : !isLoading ? (
                        <div className={`${isUsOnly() ? 'border-background-new-design' : ''}`}>
                          <div
                            className={`${isUsOnly() ? 'loyalty-banner-wrapper-new-design' : ''}`}
                          >
                            <LoyaltyBanner
                              pageCategory="isProductDetailView"
                              ratingsProductId={ratingsProductId}
                              isCompleteTheLookTestEnabled={isCompleteTheLookTestEnabled}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="product-property-section">
                          <LoaderSkelton height="60px" />
                        </div>
                      )
                    }
                    {this.getSendAnEmailComponent()}
                  </div>
                </Col>
              </Row>
              {dynamicContentPromo && dynamicContentPromo.length > 0 ? (
                <div className="promo-area-dynamic">
                  {isDynamicComponentReady ? (
                    this.renderPromoBanner(dynamicContentPromo)
                  ) : (
                    <>
                      <div className={'hide-promo'}>
                        {this.renderPromoBanner(dynamicContentPromo)}
                      </div>
                      {dynamicPromoPerfSwitch && (
                        <StyledModuleLoader aspectRatioObject={aspectRatioObjNew}>
                          <LoaderSkelton className={'module-loader'} />
                        </StyledModuleLoader>
                      )}
                    </>
                  )}
                </div>
              ) : (
                showDynamicContentLoader && (
                  <div className="promo-area-dynamic">
                    <StyledModuleLoader aspectRatioObject={aspectRatioObjNew}>
                      <LoaderSkelton className={'module-loader'} />
                    </StyledModuleLoader>
                  </div>
                )
              )}

              {this.renderPromo('bottom', this.props)}
              <Row fullBleed={{ small: true, medium: true, large: false }}>
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  <div className="product-detail-section key-feature-section">
                    {!isGiftCard &&
                      !(isNewPDPEnabled && !isMobile) &&
                      !isNewPJPPDPRedesignEnabled && (
                        <ProductDescription
                          productId={itemPartNumber}
                          productInfo={productInfo}
                          isShowMore={false}
                          shortDescription={shortDescription}
                          longDescription={longDescription}
                          color={itemColorObj && itemColorObj.color && itemColorObj.color.name}
                          isPDP
                          TCPStyleColor={TCPStyleColor}
                          wishList={wishList}
                          isNewPDPEnabled={isNewPDPEnabled}
                          primaryBrand={primaryBrand}
                          variantNumber={variantNumber}
                        />
                      )}
                  </div>
                </Col>
              </Row>
              {isRcommAboveProdDesc && isPdp1andPdp2Enabled && colorNameAvailable && (
                <React.Fragment>
                  <Row
                    className="pdp-recommendations-wrapper"
                    fullBleed={{ small: true, medium: true, large: false }}
                  >
                    <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                      <div
                        className={`${className} product-detail-section product-description-list ${hideYouMayLikeClass}`}
                      >
                        <Recommendations
                          inheritedStyles={recommendationStylesPdp1AndPdp2}
                          headerLabel={renderLabel(
                            this.pdpLabel.lbl_you_may_also_like,
                            'lbl_you_may_also_like'
                          )}
                          showPriceRange={showPriceRange}
                          {...recommendationAttributes}
                          sequence="1"
                          accordionHeader={!isPdpNewRecommendationEnabled}
                          newRecommendationEnabled={isPdpNewRecommendationEnabled}
                          pdpDataInformation={this.pdpDataInformation}
                          primaryBrand={primaryBrand}
                          isPDP
                          isRecommendationSidebar={isRecommendationSidebar}
                          isRecommendationMarginEnabled={isNewPJPPDPRedesignEnabled}
                          isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                        />
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
              {isNewPJPPDPRedesignEnabled && (
                <>
                  {productBadges && (
                    <KeyFeatures
                      productBadges={productBadges}
                      headingLabel={this.pdpSubLabelsObj.lbl_key_features}
                    />
                  )}
                  <PDPNewTabs
                    productInfo={productInfo}
                    productDetails={productDetails}
                    starRatingClicked={starRatingClicked}
                    itemPartNumber={itemPartNumber}
                    shortDescription={shortDescription}
                    longDescription={longDescription}
                    itemColorObj={itemColorObj}
                    TCPStyleColor={TCPStyleColor}
                    isNewPDPEnabled
                    wishList={wishList}
                    primaryBrand={primaryBrand}
                    isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                    activeTabSection={activeTabSection}
                    setPdpTabSectionName={setPdpTabSectionName}
                    sizeChartDetails={sizeChartDetails}
                    quickViewLabels={this.quickViewLabels}
                    categoryPathMap={categoryPathMap}
                    alternateBrand={alternateBrand}
                    isESGBadgePDPBackABEnabled={isESGBadgePDPBackABEnabled}
                    isPDPRedesignEnabled={isPDPRedesignEnabled}
                    activeTabIndex={activeTabIndex}
                    setPdpTabSectionIndex={setPdpTabSectionIndex}
                    variantNumber={variantNumber}
                    fetchShippingAndReturnsModule={fetchShippingAndReturnsModule}
                    shippingAndReturnsModuleXContent={shippingAndReturnsModuleXContent}
                    isShippedAndReturnsTabEnabled={isShippedAndReturnsTabEnabled}
                    sizeChartImageURL={sizeChartImageURL}
                  />
                </>
              )}
              {isSyteReady &&
                syteRecommendations?.isSyteEnabled &&
                syteRecommendations?.position === 'top' &&
                (syteRecos || syteComponent)}
              <Row
                className="pdp-recommendations-wrapper"
                fullBleed={{ small: true, medium: true, large: false }}
              >
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  {outfitV3WidgetEnabled && (
                    <div className="ctl-v3-container">
                      <h4 id="widget-title" className="ctl-heading">
                        Complete The Look
                      </h4>
                      <div id="stylitics-widget-container" />
                    </div>
                  )}
                  {!outfitV3WidgetEnabled && (
                    <div className="product-detail-section complete-look-section">
                      <RelatedOutfits
                        selectedColorProductId={productIdForSwatch}
                        isPDP
                        page={Constants.RECOMMENDATIONS_PAGES_MAPPING.PDP}
                        triggerStylyticsAnalytics={this.triggerStylyticsAnalytics}
                        completeLookSlotTile={completeLookSlotTile}
                        isNewPDPEnabled
                        primaryBrand={primaryBrand}
                      />
                    </div>
                  )}
                </Col>
              </Row>
              {isPdp1andPdp2Enabled && colorNameAvailable && (
                <React.Fragment>
                  {!isRcommAboveProdDesc && (
                    <Row
                      className="pdp-recommendations-wrapper"
                      fullBleed={{ small: true, medium: true, large: false }}
                    >
                      <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                        <div
                          className={`${className} product-detail-section product-description-list ${hideYouMayLikeClass}`}
                        >
                          <Recommendations
                            inheritedStyles={recommendationStylesPdp1AndPdp2}
                            headerLabel={renderLabel(
                              this.pdpLabel.lbl_you_may_also_like,
                              'lbl_you_may_also_like'
                            )}
                            showPriceRange={showPriceRange}
                            {...recommendationAttributes}
                            sequence="1"
                            accordionHeader={!isPdpNewRecommendationEnabled}
                            newRecommendationEnabled={isPdpNewRecommendationEnabled}
                            pdpDataInformation={this.pdpDataInformation}
                            primaryBrand={primaryBrand}
                            isPDP
                            isRecommendationSidebar={isRecommendationSidebar}
                            isRecommendationMarginEnabled={isNewPJPPDPRedesignEnabled}
                            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  {this.willMonetateCarouselDisplay && (
                    <Row
                      className="pdp-recommendations-wrapper"
                      fullBleed={{ small: true, medium: true, large: false }}
                    >
                      <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                        <div
                          className={`${className} product-detail-section product-description-list ${hideRecentlyViewdClass}`}
                        >
                          <Recommendations
                            inheritedStyles={recommendationStylesPdp1AndPdp2}
                            headerLabel={renderLabel(
                              this.pdpLabel.lbl_recently_viewed,
                              'lbl_recently_viewed'
                            )}
                            portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED}
                            {...recommendationAttributes}
                            sequence="2"
                            accordionHeader={!isPdpNewRecommendationEnabled}
                            newRecommendationEnabled={isPdpNewRecommendationEnabled}
                            pdpDataInformation={this.pdpDataInformation}
                            primaryBrand={primaryBrand}
                            updateShowRecentlyViewedVertically={updateShowRecentlyViewedVertically}
                            isRecommendationMarginEnabled={isNewPJPPDPRedesignEnabled}
                            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                            isPdpProductLoading={isLoading}
                            isPDP
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  {this.willMonetateCarouselDisplay && (
                    <Row
                      className="pdp-recommendations-wrapper"
                      fullBleed={{ small: true, medium: true, large: false }}
                    >
                      <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                        <div
                          className={`${className} product-detail-section product-description-list ${hideRecentlyViewdClass}`}
                        >
                          <Recommendations
                            inheritedStyles={recommendationStylesPdp1AndPdp2}
                            headerLabel={renderLabel(
                              this.pdpLabel.lbl_you_recently_viewed,
                              'lbl_you_recently_viewed'
                            )}
                            portalValue={
                              Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED_UPDATED
                            }
                            {...recommendationAttributes}
                            sequence="3"
                            accordionHeader={!isPdpNewRecommendationEnabled}
                            newRecommendationEnabled={isPdpNewRecommendationEnabled}
                            pdpDataInformation={this.pdpDataInformation}
                            primaryBrand={primaryBrand}
                            updateShowRecentlyViewedVertically={updateShowRecentlyViewedVertically}
                            isRecommendationMarginEnabled={isNewPJPPDPRedesignEnabled}
                            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                            isPdpProductLoading={isLoading}
                            isPDP
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                </React.Fragment>
              )}
              <PdpVmpDataLogger {...this.props} />
              {this.renderPromo('belowrecs', this.props)}
              <Row className="pdp-recommendations-wrapper">
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  <div className="get-candid-section">
                    {this.apiConfig.isCandidEnabled === 'true' && !isGiftCard && (
                      <DynamicModule
                        key="get-candid"
                        importCallback={() =>
                          import(
                            /* webpackChunkName:"get-candid" */ '@tcp/core/src/components/common/molecules/GetCandid'
                          )
                        }
                        productId={productId}
                        isPDP
                      />
                    )}
                  </div>
                </Col>
              </Row>
              <Row
                className="pdp-recommendations-wrapper"
                fullBleed={{ small: true, medium: true, large: false }}
              >
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  {!this.isLowTier &&
                    showBazaarVoice &&
                    !isGiftCard &&
                    isLoggedIn !== null &&
                    !isNewPJPPDPRedesignEnabled && (
                      <div className="reviews-anchoring-wrapper">
                        <ProductReviewsContainer
                          expanded={false}
                          reviewsCount={productInfo.reviewsCount}
                          ratingsProductId={productInfo.ratingsProductId}
                          isClient={isClient()}
                          bazaarVoice={productDetails.currentProduct.bazaarVoice}
                          starRatingClicked={starRatingClicked}
                          handleRatingClick={this.handleRatingClick}
                        />
                      </div>
                    )}
                </Col>
              </Row>
              {toastModalState?.showToast && (
                <ToastModal
                  className={className}
                  duration={toastModalState?.duration}
                  showToastModalAction={showToastModalAction}
                />
              )}
              {isSyteReady &&
                syteRecommendations?.isSyteEnabled &&
                syteRecommendations?.position === 'bottom' &&
                (syteRecos || syteComponent)}
              {!isPixleeWidget ? this.getBazaarVoiceScript() : <></>}
              {this.justFewLeftSection(colorProduct)}
            </>
          ) : (
            <>{renderLabel(this.pdpLabel.lbl_page_not_found, 'lbl_page_not_found')}</>
          )}
        </div>
      </BadgesProvider>
    );
  }
}

ProductDetailView.propTypes = {
  className: PropTypes.string,
  addToBagError: PropTypes.string,
  handleAddToBag: PropTypes.func.isRequired,
  productDetails: PropTypes.shape({}),
  productInfo: PRODUCT_INFO_PROP_TYPE_SHAPE,
  shortDescription: PropTypes.string,
  itemPartNumber: PropTypes.string,
  longDescription: PropTypes.string,
  breadCrumbs: PropTypes.shape([]),
  currency: PropTypes.string,
  currencyAttributes: PropTypes.shape({}).isRequired,
  onAddItemToFavorites: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  alternateSizes: PropTypes.shape({
    key: PropTypes.string,
  }),
  alternateStyles: PropTypes.shape({
    key: PropTypes.string,
  }),
  isKeepAliveEnabled: PropTypes.bool,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  sizeChartDetails: PropTypes.shape([]),
  asPathVal: PropTypes.string,
  isValidProduct: PropTypes.bool.isRequired,
  topPromos: PropTypes.string,
  middlePromos: PropTypes.string,
  dynamicContentPromo: PropTypes.string,
  bottomPromos: PropTypes.string,
  belowrecsPromos: PropTypes.string,
  trackPageLoad: PropTypes.func,
  isSearchPage: PropTypes.bool,
  router: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOnModelAbTestPdp: PropTypes.bool,
  isAbPdpPlaEnabled: PropTypes.bool,
  completeLookSlotTile: PropTypes.shape({}),
  isInternationalShipping: PropTypes.bool.isRequired,
  navigateType: PropTypes.string,
  wishList: PropTypes.func.isRequired,
  searchedText: PropTypes.string,
  isShowPriceRangeKillSwitch: PropTypes.bool.isRequired,
  showPriceRangeForABTest: PropTypes.bool.isRequired,
  isPlcc: PropTypes.bool.isRequired,
  storeId: PropTypes.string,
  trackClick: PropTypes.func.isRequired,
  imgConfigVal: PropTypes.shape([]),
  resetCountUpdate: PropTypes.func.isRequired,
  getSocialProofData: PropTypes.func,
  countUpdated: PropTypes.bool,
  isCompleteTheLookTestEnabled: PropTypes.bool,
  hidePriceDisplay: PropTypes.bool,
  isDefaultBreadCrumb: PropTypes.bool.isRequired,
  addBtnMsg: PropTypes.string.isRequired,
  multipackProduct: PropTypes.string.isRequired,
  multiPackCount: PropTypes.string.isRequired,
  multiPackThreshold: PropTypes.string.isRequired,
  partIdInfo: PropTypes.string.isRequired,
  getAllNewMultiPack: PropTypes.shape([]).isRequired,
  isRecommendationAvailable: PropTypes.bool.isRequired,
  isPerUnitPriceEnabled: PropTypes.bool,
  getDetails: PropTypes.shape([]).isRequired,
  selectedMultipack: PropTypes.string.isRequired,
  TCPStyleQTY: PropTypes.number.isRequired,
  checkForOOSForVariant: PropTypes.bool.isRequired,
  isBrierleyPromoEnabled: PropTypes.bool,
  isOosPdpEnabled: PropTypes.bool,
  isPdpNewRecommendationEnabled: PropTypes.bool,
  isPdp1andPdp2Enabled: PropTypes.bool,
  selectColorToHover: PropTypes.func,
  largeImageNameOnHover: PropTypes.string,
  hasABTestForPDPColorOrImageSwatchHover: PropTypes.bool,
  initialMultipackMapping: PropTypes.shape([]).isRequired,
  singlePageLoad: PropTypes.bool.isRequired,
  setInitialTCPStyleQty: PropTypes.bool.isRequired,
  resetProductDetailsDynamicData: PropTypes.shape([]).isRequired,
  onSetLastDeletedItemIdAction: PropTypes.func,
  formValues: PropTypes.shape([]).isRequired,
  deleteFavItemInProgressFlag: PropTypes.bool,
  addToBagErrorId: PropTypes.string,
  disableMultiPackTab: PropTypes.bool,
  getDisableSelectedTab: PropTypes.func.isRequired,
  istMultiColorNameEnabled: PropTypes.bool.isRequired,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  fromPLPPage: PropTypes.bool,
  availableTCPmapNewStyleId: PropTypes.shape([]),
  isPDPSmoothScrollEnabled: PropTypes.bool,
  isHiddenPDPAltImageEnabled: PropTypes.bool,
  socialProofMessage: PropTypes.string,
  isFamilyOutfitEnabled: PropTypes.bool,
  isNewPDPEnabled: PropTypes.bool,
  isABTestLoaded: PropTypes.bool,
  isShowBrandNameEnabled: PropTypes.bool,
  openModal: PropTypes.func,
  isVerticalCTLEnabled: PropTypes.bool,
  previousSearchPage: PropTypes.bool,
  appliedFiltersPLP: PropTypes.shape({
    v_tcpsize_uFilter: PropTypes.shape([]),
  }),
  appliedFiltersSLP: PropTypes.shape({
    v_tcpsize_uFilter: PropTypes.shape([]),
  }),
  isFromPLPPage: PropTypes.bool,
  isFromSLPPage: PropTypes.bool,
  trackWishListClick: PropTypes.func,
  isFamilyOutfitRightViewEnabled: PropTypes.bool,
  setProductDataForReviewActn: PropTypes.func,
  isRedesignedPdpDesktopView: PropTypes.bool,
  currentCategoryIdPLP: PropTypes.string,
  isPdpSsr: PropTypes.bool,
  isRecommendationSidebar: PropTypes.bool,
  isTakeDownRedirectionEnabled: PropTypes.bool,
  clearAddToBagError: PropTypes.func,
  isPlpPdpAnchoringEnabled: PropTypes.bool,
  isAddBgdToTransparentImgEnabled: PropTypes.bool,
  initialColorConsolidationMultipackMapping: PropTypes.shape([]),
  isColorConsolidationEnabled: PropTypes.bool,
  isBestSellerBackAbEnabled: PropTypes.bool,
  isTopRatedBadgeEnabled: PropTypes.bool,
  isMostFavoritedBadgeEnabled: PropTypes.bool,
  closeBirthdayModal: PropTypes.func,
  isBMModalOpen: PropTypes.bool,
  isPixleeWidget: PropTypes.bool,
  showDynamicContentLoader: PropTypes.bool,
  dynamicPromoPerfSwitch: PropTypes.bool,
  fetchAdditionalPromoModule: PropTypes.func,
  additionalPromoModuleXContent: PropTypes.shape({}),
  additionalPromoModuleXContentId: PropTypes.string,
  imageConfigWithoutDPR: PropTypes.string,
  isFromHeroProductTile: PropTypes.bool,
  fromBagPage: PropTypes.bool,
  isAISimilarStyleEnabled: PropTypes.bool,
};

ProductDetailView.defaultProps = {
  className: '',
  productDetails: {},
  longDescription: '',
  shortDescription: '',
  breadCrumbs: [],
  currency: '',
  itemPartNumber: '',
  productInfo: {},
  addToBagError: '',
  isLoggedIn: false,
  alternateSizes: {},
  alternateStyles: {},
  isKeepAliveEnabled: false,
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  trackPageLoad: () => {},
  getSocialProofData: () => {},
  sizeChartDetails: [],
  asPathVal: '',
  topPromos: '',
  middlePromos: '',
  dynamicContentPromo: '',
  bottomPromos: '',
  belowrecsPromos: '',
  isSearchPage: false,
  isOnModelAbTestPdp: false,
  isAbPdpPlaEnabled: false,
  completeLookSlotTile: {},
  navigateType: '',
  searchedText: '',
  storeId: null,
  imgConfigVal: [],
  countUpdated: false,
  isCompleteTheLookTestEnabled: false,
  hidePriceDisplay: false,
  isPerUnitPriceEnabled: false,
  isBrierleyPromoEnabled: false,
  isOosPdpEnabled: false,
  isPdpNewRecommendationEnabled: false,
  isPdp1andPdp2Enabled: true,
  selectColorToHover: () => {},
  largeImageNameOnHover: '',
  hasABTestForPDPColorOrImageSwatchHover: false,
  onSetLastDeletedItemIdAction: () => {},
  deleteFavItemInProgressFlag: false,
  addToBagErrorId: '',
  disableMultiPackTab: false,
  isDynamicBadgeEnabled: false,
  fromPLPPage: false,
  availableTCPmapNewStyleId: [],
  isPDPSmoothScrollEnabled: false,
  socialProofMessage: '',
  isFamilyOutfitEnabled: false,
  isNewPDPEnabled: false,
  isABTestLoaded: false,
  isShowBrandNameEnabled: false,
  openModal: () => {},
  isHiddenPDPAltImageEnabled: false,
  isVerticalCTLEnabled: false,
  previousSearchPage: false,
  appliedFiltersPLP: {
    v_tcpsize_uFilter: [],
  },
  appliedFiltersSLP: {
    v_tcpsize_uFilter: [],
  },
  isFromPLPPage: false,
  isFromSLPPage: false,
  trackWishListClick: () => {},
  isFamilyOutfitRightViewEnabled: false,
  setProductDataForReviewActn: () => {},
  isRedesignedPdpDesktopView: false,
  currentCategoryIdPLP: '',
  isPdpSsr: false,
  isRecommendationSidebar: false,
  isTakeDownRedirectionEnabled: false,
  clearAddToBagError: () => {},
  isPlpPdpAnchoringEnabled: false,
  isAddBgdToTransparentImgEnabled: false,
  isColorConsolidationEnabled: false,
  initialColorConsolidationMultipackMapping: [],
  isBestSellerBackAbEnabled: false,
  isTopRatedBadgeEnabled: false,
  isMostFavoritedBadgeEnabled: false,
  closeBirthdayModal: () => {},
  isBMModalOpen: false,
  isPixleeWidget: false,
  showDynamicContentLoader: false,
  dynamicPromoPerfSwitch: false,
  fetchAdditionalPromoModule: () => {},
  additionalPromoModuleXContentId: '',
  additionalPromoModuleXContent: null,
  imageConfigWithoutDPR: '',
  fromBagPage: false,
  isFromHeroProductTile: false,
  isAISimilarStyleEnabled: false,
};

export default errorBoundary(withStyles(ProductDetailView, ProductDetailStyle));
